/* eslint-disable */
module.exports = {
  copyright: "Copyright  © 2016-2024 巨立云  iot.joylive.com  All Rights Reserved. 备案号: 苏ICP备14058511号-2",
  cancel: "取消",
  brandManage: "电梯品牌管理",
  totalAmountRO: "总维修工单数",
  standbyHours: "待命时长",
  year: "年度",
  newMaintenanceBatches: "新增维保批次",
  stopOnFloor: "停止楼层",
  illegalCharactersInNineNo: "96333编号含有非法字符",
  approved: "审核通过",
  hoursRO: "维修工时数",
  usedNotDelete: "已使用，不能删除",
  poor: "差",
  distanceLengthForUrgentRepair: "抢修路程历程(公里)",
  setUp: "设置",
  videoPlayback4: "4G视频回放",
  excellent: "优秀",
  paidMaintenance: "有偿保养",
  totalQualifiedRateQDMC: "质量部自行维保检查总合格率",
  selectCompany: "请选择公司",
  entertainmentPlace: "娱乐场所",
  signOut: "退出",
  maintenanceContract: "保养合同",
  version: "版本",
  overload: "超载",
  airport: "机场",
  billingRecord: "开票记录管理",
  elevatorInfo: "电梯档案",
  newPaymentInfo: "新增付款记录",
  statusOffline: "电梯状态: 离线 ",
  fillLoseReason: "请务必填写丢失原因",
  unfinishedOrderTotal: "未完成总数（待接收，处理中，已暂停）",
  malfunctionNature: "故障性质",
  responseTO: "困人平均响应(分钟)",
  rescuerQualificationManagement: "救援人员资质审核管理",
  upPassingChime: "上到站钟",
  role: "角色",
  savePlanRemark: "保存计划备注",
  deliveryTime: "交付时间",
  inspectionTerms: "核查条件",
  historyRoute: "员工GPS轨迹图",
  viewEleInfo: "查看电梯档案",
  maintenanceBatch: "维保批次",
  notHaveTop: "参考公司没有创建0级小组",
  planExpiring: "维保计划到期列表",
  qualifiedRateNEMC: "新梯收梯维保检查合格率",
  PASSED: "合格",
  normalAnnual: "正常年检",
  result: "处理结果",
  fillInReason: "请务必选择超期理由",
  to612Months: "6-12个月",
  hoursTO: "困人工时数",
  companyNotHaveTop: "该公司没有创建0级小组",
  canNotUpdateMaintenanceStaff: "该公司不可以更新维保人员",
  servicePlatformUnitsList: "服务平台台量表",
  thirdFaultLevel: "故障等级三级",
  selectInspectStatus: "请选择核查结果",
  statusMalfunction: "电梯状态: 故障 ",
  close: "关闭",
  resolved: "已解决",
  lastMaintenanceDate: "上次维保时间",
  address: "详细地址",
  mainSchedule: "保养情况一览表",
  locationContrast: "位置核对",
  qualifiedQDMC: "质量部维保检查合格数",
  sNTwo: "网点二",
  servicePlatformData: "服务平台数据报表",
  statusRecondition: "电梯状态: 检修 ",
  companyData: "公司数据",
  kunshanNo: "昆山119编号",
  commissionMaintenanceUnitsFree: "委托保养台量(免保)",
  renewLostInfo: "管理续签、丢失、开票、收款等信息",
  SUSPEND: "已暂停",
  cloudPush: "云推送",
  doorOpenMode: "开门方式",
  youCanNotDeleteElevator: "已有公司使用该电梯，您不能删除它",
  responseRO: "维修平均响应(分钟)",
  openDoorBtnShow: "开门按钮显示",
  putAway: "收起",
  staffInfo: "员工信息",
  excellentOrderTotal: "优秀评价总数",
  quarterM: "季度保养",
  keywords: "关键词",
  doorOpen: "开门到位",
  lastAnnualInspectionDate: "年检时间",
  qrCodeLogo: "二维码logo",
  factoryNo: "出厂编号",
  intelligenceCode: "智能硬件注册码",
  good: "良好",
  averageResponse: "平均响应(分钟)",
  roleNameContainType: "角色名应包含公司类型",
  notEvaluatedOrderTotal: "未评价总数",
  replacements: "配件",
  tractionFreight: "曳引驱动载货电梯",
  export: "导出",
  ele: "电梯",
  shouldNotBeGreaterThan: "应小于该发票号应收金额",
  area: "维保区域",
  trappedFault: "困人故障",
  maintenanceUnits: "维保台量",
  elevatorNo: "电梯工号",
  carTopInput: "轿顶输入状态",
  totalAmountMO: "总维保工单数",
  noMatchingElevatorFound: "没有匹配的电梯",
  oldPassword: "旧密码",
  chooseScanCode: "请选择是否扫描二维码",
  invoiceIssuerContact: "发票联系人",
  finishedAI: "超期已完成",
  editElevatorBrand: "编辑电梯品牌",
  faultCode: "故障代码",
  videoMonitor: "视频监控",
  codeLocManage: "扫码位置管理",
  success: "成功",
  actualCompletionDate: "实际完成时间",
  nextStep: "下一步",
  maintenanceHeadCount: "保养人头数",
  unsolved: "未解决",
  followUpWorkOrders: "后续维修工单",
  halfAYear: "半年保养",
  aiStatus: "年检状态",
  workOrderManagement: "工单管理",
  workOrderInquiry: "电梯工单查询",
  expiryDate: "合同到期日",
  totalHoursForMaintenance: "保养总工时(小时)",
  statusAll: "电梯状态: 全部 ",
  maintenanceCurrentPerson: "当前维保人",
  generalOrder: "通用工单",
  manufactureDate: "出厂日期",
  selectContract: "请选择应选保养合同",
  end: "结束",
  resendAfter: "秒后可重新发送",
  lostTrustee: "失信被执行人",
  useMode: "您确定使用基础模板吗?",
  ObjectDoesNotExist: "不存在此对象",
  pThree: "产品三",
  companyType: "公司类型",
  paymentMode: "付款方式",
  completeCD: "完整的合同数据库",
  alternativeStaff: "备选人员姓名",
  scanCode: "扫码",
  addContract: "添加保养合同",
  contractNoExists: "合同号已存在",
  satisfactionEvaluation: "满意度统计数据",
  trappedBeing: "困人处理中",
  elevatorStatus: "电梯状态",
  selectLast: "请选择上次年检日期",
  AgedKidsPregnantInCar: "有无老人、小孩、孕妇、特殊人士",
  inOutTerminalState: "主控板输入/输出端子状态",
  shaft: "井道",
  enterOrder: "进场工单",
  nextAnnualInspectionDate: "下次年检日期",
  noMatchingScanPosition: "没有匹配的扫码位置",
  statusInfo: "状态信息",
  UidNotExist: "uid不存在",
  elevatorFile: "电梯档案",
  problemSolvingResponseTime: "解决响应时间(分钟)",
  number: "序号",
  fileNotMatch: "文件不符合要求",
  directSignal: "直达信号",
  carTopOutput: "轿顶输出状态",
  videoChat: "视频通话",
  workBillPush: "工单已推送",
  organizationalStructure: "组织架构",
  order: "顺序",
  automaticSidewalk: "自动人行道梯",
  period: "时间段",
  consignee: "收货联系人",
  maintenanceLevelInfo: "维保等级信息",
  outOfTextLength: "中文最大限制：10",
  contractsInfo2: "保养合同信息",
  tiltAngle: "倾斜角",
  contentNotEmpty: "请填写项次内容",
  invoiceNoExists: "发票号已存在",
  theAmountCollected: "您填写的收款金额",
  insReport: "自检报告",
  generationTime: "生成时间",
  sceneDescription: "现场描述",
  mobilePhone: "移动电话",
  inspectionQualifiedUnits: "官检合格台数",
  repairHeadCount: "抢修人头数",
  statusIncorrect: "状态有误",
  ACCOMPLISH: "已完成",
  elevatorDis: "电梯分布统计",
  loginFails: "登录失败",
  elevatorEvent: "电梯事件",
  other: "其他",
  addElevator: "添加电梯",
  city: "市",
  save: "保存",
  login: "登 录",
  newDue: "新增到期",
  valid: "有效",
  Invalid: "无效",
  maintenanceUnitsChange: "保养台数变动(单位:台)",
  deletedUnsuccessful: "删除失败",
  confirmPassword: "确认密码",
  validateContract: "合同生效(元/月度)",
  joylive: "巨立云",
  contractInformation: "联系方式",
  areaManager: "区域经理",
  totalAmountCFO: "总用户评价数",
  product: "产品",
  invalidStatus: "无效的状态",
  usernameNotExist: "用户名不存在",
  mobileIncorrect: "请填写正确的电话,格式:158XXXXXXXX",
  relatedIssues: "事宜",
  staffNoAuthority: "该人员无权限维修该电梯",
  unqualifiedSMC: "自行维保检查不合格数",
  hoursMO: "保养工时数",
  to12Years: "1-2年",
  operationNode: "操作节点",
  otherMonth: "其他月份",
  institutionsBuilding: "机关单位",
  sNThree: "网点三",
  contractAwardUnits: "发包台数",
  iOSApp: "iOS版app",
  importedFailed: "导入失败",
  ModeJoylive: "基础模板",
  dueFreeMaintenance: "免保到期",
  unitYuan: "单位：元",
  effectiveDate: "合同生效日",
  residentialBuilding: "住宅小区",
  aRepairRO: "总维修平均修理(分钟)",
  chooseBrand: "请选择品牌",
  faultRate: "故障率",
  everyPageShow: "每页显示",
  enterCompanyName: "请填写公司名称",
  verifyUser: "审核用户",
  statusReport: "状态报告",
  newRepairRecord: "新增报修信息",
  managerNotSame: "负责人和员工账号不能相同",
  noUseFunction: "您无权限使用该功能",
  selectMaintenanceLevelInfo: "请选择维保等级",
  anyoneInjured: "有无人员受伤",
  maintenanceCompany: "维保公司",
  ignoredFaultRecord: "故障忽略记录",
  unqualifiedSMCIn: "部门内自行维保检查不合格数",
  totalHoursOfUrgentRepair: "抢修保养总工时(小时)",
  maintenanceType: "保养类型",
  elevatorMonitoringDetails: "电梯监控详情",
  userFail: "获取当前用户失败",
  chooseRecordOperational: "请选择是否记录操作过程",
  longitude: "经度",
  overhaulPerformed: "大修承接",
  reassignOrder: "工单改派",
  modifyOrder: "工单修改",
  mapView: "电梯聚合分布",
  all: "入网台量",
  elevatorModel: "电梯型号",
  new: "新增",
  thisBrandExists: "已存在此品牌",
  progressReport: "进度报告",
  renewalStatus: "续签状态",
  materialName: "物料名称",
  totalAmount: "合计",
  halfMonth: "半月保养",
  unit: "台量",
  runningTimes: "运行次数",
  groupHas: "该公司0级小组已存在",
  maintenanceTotalUnits: "维保总台量",
  violation: "违规",
  lostManage: "丢失管理",
  totalQDMC: "质量部维保检查总台量",
  contractAmount: "合同金额(元)",
  exposureEvent: "曝光事件",
  renewPaidMaintenance: "有偿续签",
  doYouWantToIgnore: "您确定忽略吗?",
  lastPageText: "尾页",
  annualVolumeStatistics: "年度台量统计",
  unitsSMC: "自行维保检查台量",
  accountReceivable: "应收账款",
  billNumber:"工单号",
  basData: "基础资料",
  warningType:'报警类型',
  accountName: "账号名称",
  companySlogan: "宣传标语",
  totalQualifiedRateNEMC: "新梯收梯维保检查总合格率",
  partOfContractLost: "合同已部分丢失",
  qualifiedNEMC: "新梯收梯维保检查合格数",
  otherStaff: "其他人员",
  energySaving: "节能",
  units: "单位",
  personInfo: "管理维保人员的编号、姓名、状态、工单数量、考评等级等",
  enterBillingDate: "请填写开票日期",
  times: "次",
  notSatisfied: "不满意",
  removeEleNo: "您无权限删除小组电梯数据",
  today: "当月",
  elevatorBrand: "电梯品牌",
  userNoPer: "对不起，您没有权限登录此系统",
  department: "部门",
  monthlyStatistics: "月份工单类型统计",
  picturesNumberLess: "拍照数量不能超过5张",
  vehicleMilesTravelT: "车辆行使里程数(困人)",
  floorsNum: "楼层数",
  selectElevatorsYouNeed: "请选择您需要的电梯",
  serviceStaff: "报障人员",
  reportAnalysis: "报表分析",
  drawer: "开票人",
  yearEnd: "年度保养",
  vehicleMilesTravelM: "车辆行使里程数(保养)",
  staffNameExists: "员工姓名已存在",
  caseTwo: "案例二",
  optimumSize: "宽度：30-107(像素),高度：30-45(像素)",
  urgentRepairManHour: "抢修人工",
  repairTwo: "修理",
  eleListExpiringDate: "电梯年检时间到期列表",
  managerMu: "慕经理",
  theNumberOfTimesVerify: "即将第几次半月保养必须在1-24之间",
  dataOverview: "数据总览",
  signIn: "登录",
  maintenance: "保养",
  maintenanceContractNo: "合同编号",
  relevantCompany: "相关单位",
  aResponseTO: "总困人平均响应(分钟)",
  reason: "理由",
  generalVATInvoice: "普票",
  maintain: "维保",
  paidMaintenanceUnits: "有偿台数",
  CollectionDateIsNotRight: "收款日期不正确",
  eleCanNotDelete: "您不能删除已产生记录的电梯",
  enterReceiptDays: "请填写收款日期",
  rectify: "整改",
  resolvedPartly: "部分解决",
  password: "密码",
  enterStaffName: "请填写员工姓名",
  trappedNumber: "被困人数",
  jan: "1月",
  subcontractCompany: "分包公司",
  fillInEndTime: "请选择结束时间",
  downPassingChime: "下到站钟",
  lightCurtain: "光幕",
  fillTag: "请填写扫码标签",
  selfMaintenanceUnits: "自保台数",
  partialRenew: "部分续签",
  apr: "4月",
  accessoriesNumber: "配件单号",
  handleOrder: "处理工单",
  androidApp: "android版app",
  controllerType: "控制器类型",
  youCanNotDeleteContract: "已有电梯使用该保养合同，您不能删除它",
  inspectPage: "核查页面",
  enterInvoiceNo: "请填写发票号",
  doYouWantToRemove: "您确定移除吗?",
  noRelevantData: "无相关数据",
  productDistribution: "产品分布",
  groupName: "小组名称",
  installationExecution: "安装合同执行",
  exposureTable: "曝光台",
  terminalValid: "端子有效",
  timeBeforeToday: "时间不得小于今天",
  totalPageBeforeText: "共",
  totalHoursMRO: "总保养维修工时数",
  maintenanceService: "维保服务",
  noStats: "无相关数据，请另选其他时间段或区域",
  fillInEleNum: "请填写电梯工号",
  unqualifiedNEMC: "新梯收梯维保检查不合格数",
  invoiceAmountGreaterThan: "开票金额应大于0,格式:0.00",
  selfMaintenanceUnitsFree: "自行保养台量(免保)",
  basicData: "基础数据",
  legalOrg: "法人或其他组织",
  totalQualifiedNEMC: "新梯收梯维保检查总合格数",
  faultHistory: "电梯故障数据库",
  selectOrderType: "请选择工单类型",
  selectElevatorType: "请选择电梯类型",
  takeSteps: "采取措施",
  nominalWidth: "名义宽度",
  staffName: "员工姓名",
  comLogo: "公司商标",
  UnifyTheSocialCreditCode:"统一社会信用代码",
  othersReason: "其他原因",
  putAwayFilter: "收起筛选",
  downloadTemplate: "下载模板",
  staffManagement: "员工管理",
  upCall: "上召",
  speed: "速度",
  press: "气压",
  personCount: "载人数",
  dataSynchronization: "数据同步",
  refresh: "刷新",
  clickForDetails: "点击了解详情",
  updateLog: "更新日志",
  howManyDaysToComplete: "完成所需天数",
  efficiencyReport: "效率报告",
  invoiceDeliveryAdd: "发票邮寄地址",
  invoiceIssuerPhone: "发票联系电话",
  qrOptimumSize: "宽度：30-1080(像素),高度：30-720(像素)",
  topLevel: "0级",
  totalPageAfterText: "页",
  undetermined: "待定",
  amountCFO: "用户评价数",
  anInManage: "年检管理",
  amountOrders: "工单数",
  endTime: "结束时间",
  underConstruction: "功能开发中，敬请期待",
  lostPaidMaintenance: "有偿丢失",
  monitorCheck: "请选择是否查看视频监控",
  groupManagement: "小组管理",
  exportPeriodIncorrect: "导出时间段不正确",
  functionCode: "功能码",
  upkeepContracts: "合同管理",
  doYouWantToReuse: "您确定恢复使用吗?",
  improperUse: "客户使用不当",
  eleListExpiring: "电梯年检时间到期列表",
  operator: "操作人",
  to36Months: "3-6个月",
  exportFilterInaccuracy: "请正确筛选后导出",
  totalUnitsSMC: "自行维保检查总台量",
  view: "查看",
  repairOrderNumbers: "完成维修工单数量",
  school: "学院校园",
  unfinishedRO: "维修工单未完成数",
  certificatePhoto: "证书照",
  dumbWaiter: "杂物电梯",
  workOrder: "工单",
  trapped: "困人",
  sNFour: "网点四",
  unclosed: "未结束",
  telephone: "固定电话",
  serviceCenterIOT: "物联网服务平台数据报表(服务中心总表)",
  maintainCustomerEnvironmentSecurity: "维护客户环境和安全",
  onSiteContactPerson: "现场联系人",
  aug: "8月",
  selectAll: "全选添加",
  changeAccountNot: "账号已使用，不可修改",
  totalAmt: "合计总价",
  amountTO: "困人工单数",
  theNTimeOfMaintenance: "第n次保养",
  remouldBilling: "改造开票",
  name: "名称",
  faultTimes: "故障次数",
  addParentElevators: "添加父级所有电梯",
  projectName: "项目名称",
  lastStaff: "上次保养员",
  relatedMaintenanceOrderNo: "关联保养合同号",
  invalidRequest: "非法请求",
  aResponseRO: "总维修平均响应(分钟)",
  import: "导入",
  pwdFormat: "密码格式：使用8位以上包含数组、字母或特殊字符的组合。",
  prePageText: "上一页",
  description: "描述",
  smsNumber: "通知接收号码",
  video: "视频",
  maintenanceAttr: "维保属性",
  enterProjectName: "请填写项目名称",
  resendCode: "重新发送校验码",
  countInfo: "统计合同相关信息",
  productionDate: "生产日期",
  todoAI: "待年检",
  lableStyle: "标签样式",
  nov: "11月",
  dynamicDetection: "动态检测",
  accessories: "配件商城",
  manageContent: "管理工单相关的所有内容",
  unfinishedOrders: "未完成总数",
  issueInvoice: "开票",
  pendingMatters: "未决事宜",
  unfinishedTO: "困人工单未完成数",
  brandData: "电梯品牌数据",
  firstFaultLevel: "故障等级一级",
  naturalPerson: "自然人",
  residenceName: "小区名称",
  approvalStatus: "审核状态",
  totalTrappedRate: "总困人率",
  hours: "小时",
  selfInsFinish: "自检已完成",
  yes: "是",
  numberOfPictures: "拍照数量",
  selectParentGroup: "请选择父级名称",
  nodeTwo: "节点二",
  remoteRealTime: "远程实时监控电梯运行情况",
  distanceTimeConsumingForMaintenance: "保养路程耗时(小时)",
  amountRO: "维修工单数",
  softwareTheLatestVersion: "软件已是最新版本",
  viewOrder: "查看工单",
  elevatorNoNotExists: "电梯工号不存在",
  loseReason: "丢失原因",
  maintenanceVolumeStatistics: "保养台量统计",
  instantMessage: "即时消息",
  quotation: "报价",
  disNotRight: "显示楼层格式不正确",
  finance: "财务",
  orderType: "工单类型",
  anySearchInfo: "通过输入任意关键字或选择不同的选项，您可以轻松搜索任意一台产品，并查看它的实时数据",
  totalHoursRO: "总维修总工时数",
  renewalNo: "续签合同号",
  refusedOrderTotal: "工单拒绝总数",
  importedSuccessfully: "已导入",
  billing: "开票(元/月度)",
  beaconNo: "云盒编号",
  logout: "退出",
  totalQualifiedSMC: "自行维保检查总合格数",
  FAILED: "不合格",
  buildingNo: "楼栋号",
  RescueMap:"救援地图",
  deliveryAddress: "收货地址",
  functionSelection: "功能选择",
  userInformation: "用户信息",
  techConsultation: "技术咨询",
  purchaseNo: "采购订单号",
  pushedFailed: "推送失败",
  manageBasicInfo: "管理保养合同基础信息",
  sNFive: "网点五",
  statisticalEndDate: "统计结束日期",
  choosePerson: "选择人员",
  EVALUATION: "待评价",
  newPassword: "新密码",
  completeRateRO: "维修工单完成比例",
  nominalSpeed: "名义速度",
  timingError: "请输入正确的持续时间",
  projectAliasAlreadyExists: "使用位置已存在",
  validPictures: "请填写有效的拍照张数",
  dangerTips: "更改本页面所有内容都会直接影响现场标识张贴及员工作业，请谨慎操作！",
  selectTips: "请选择节点库，否则无法新增安装工单操作",
  DONEREFUSE: "拒绝已处理",
  recondition: "检修",
  dynamicSupervision: "监察动态",
  pendingIssuesOld: "未决事宜",
  complaintsHotline: "投诉电话",
  reset: "重置",
  physicalFloor: "物理楼层",
  commercialAndResidentialBuilding: "商住综合",
  selectGroupName: "请选择小组名称",
  moderateOrderTotal: "一般评价总数",
  contractNo: "合同编号",
  selectNext: "请选择下次年检日期",
  fullLoad: "满载信号",
  doorCloseOutput: "关门输出",
  totalHoursTO: "总困人工时数",
  setFilterButtons: "根据电梯不同的健康状况设置了筛选按钮，一键分类",
  unknown: "未知",
  low: "低",
  maintenanceItemsConfiguration: "维保项次配置",
  completeRateCFO: "用户评价完成比例",
  startTime: "开始时间",
  finishTime: "结束时间",
  workOrderStatus: "工单状态",
  TOFIX: "转维修",
  onlineMonitoring: "远程监控",
  contractNature: "合同性质",
  maintenanceMonth: "保养月报",
  more: "更多",
  staffAccount: "员工账号",
  remouldPerformed: "改造承接",
  numberFiveStar: "满意度(5星)数",
  roleEm: "角色不能为空",
  informationStatistics: "信息统计",
  numberNotFiveStar: "满意度(非5星)数",
  currentMaintenanceUnits: "当前保养台数(单位:台)",
  receivedAmount: "已收款金额(元)",
  newMaintenanceAccount: "新增维保账号",
  completeRateTO: "困人工单完成比例",
  loseContract: "丢失合同",
  newPaidMaintenance: "有偿新增",
  importMaintenanceProgram: "导入维保计划",
  staffState: "员工状态",
  distanceLengthForMaintenance: "保养路程历程",
  companyAddress: "公司地址",
  inspectReason: "不合格原因",
  sendApp: "手机端APP已推送",
  multiBrandLift: "多品牌电梯",
  completeRateMO: "维保工单完成比例",
  noMatchingProjectNameFound: "没有匹配的项目名称",
  feb: "2月",
  displayFilter: "显示筛选",
  searchTerms: "没有找到您期望的内容，请尝试其他搜索词，或拨打巨立云服务热线:0512-36607152",
  num: "数量",
  pTwo: "产品二",
  fillInSTime: "请选择开始时间",
  homeLift: "家用",
  homeLift1: "家用梯",
  deleteElevatorBrand: "您不能删除已使用的电梯品牌",
  completeCFO: "用户评价完成数",
  serviceAttitude: "服务态度",
  contractsInfo: "保养合同信息",
  qualifiedSMCIn: "部门内自行维保检查合格数",
  errorHappened: "出错了",
  ratedLoad: "额定载重",
  forgotPwd: "忘记密码？",
  enterRightNum: "请填写正确的数量,格式:0",
  aLittlePoor: "有点差",
  day: "(天)",
  halfAYearM: "半年保养",
  group: "小组",
  nodeThree: "节点三",
  totalHoursMO: "总保养总工时数",
  specialVATInvoice: "专票",
  created: "已创建",
  minutes: "分钟",
  sendTwo: "派发",
  noRelatedStaff: "无相关人员",
  faultTime: "故障发生时间",
  inspectStatus: "核查状态",
  editDate: "电梯年检时间编辑",
  ACCEPT: "待执行",
  expiringReminder: "到期提醒",
  factoryBuilding: "工厂企业",
  regionAttribute: "区域属性",
  overhaul: "大修",
  checkMaintenance: "查看保养合同",
  noAddressName: "电梯工号,地址,项目名称等",
  eleRemark3: "2、液压乘客电梯及液压载货电梯请选择“液压梯”模板",
  forbidUnsuccessful: "禁用失败",
  keyAccurate: "输入双引号加内容可精确查找，例如:'XXX'",
  eleRemark2: "1、曳引驱动乘客电梯、曳引驱动载货电梯、强制驱动载货电梯及杂物电梯请选择“直梯”模板",
  noCompanyOrTopLevel: "没有匹配的公司或公司没有创建0级数据，无法参考",
  eleRemark1: "此为工单模板类型，具体电梯类型以电梯档案中维护的品种为准。",
  materialNo: "物料编码",
  verificationCodeIs: "您的验证码是",
  qrFormat: "扫码位置格式：2-4个汉字或者2-6个字母、数字组合",
  forbid: "禁用",
  personnelActivityReport: "人员活动报告",
  REFUSE: "已拒绝",
  malfunctionState: "故障状态",
  ineffectiveHoursAnalysis: "非有效工时分析",
  firstPageText: "首页",
  general: "一般",
  halfMonthM: "半月保养",
  usedUnitNoAlreadyExists: "使用单位内编号已存在",
  parallel: "并联",
  annualStatistics: "年度工单类型统计",
  registrationCode: "注册代码",
  hospital: "医院",
  dailyOnDutyTime: "日均在岗时间",
  errorSelectNode: "请选择正确的操作节点",
  temp: "温度",
  renewalContent: "改造内容",
  percentageFiveStar: "满意度(5星)百分比",
  deviceCode: "设备代码",
  positiveDrive: "强制驱动载货电梯",
  totalUnits: "总台数",
  durationNotRight: "合同时长不正确",
  noPersonFind: "该范围内无符合条件的维保人员，已为您扩大搜索范围",
  unfinishedMO: "维保工单未完成数",
  needInvoice: "待开票",
  enterRightPrice: "请填写正确的单价,格式:0.00",
  unqualifiedQDMC: "质量部自行维保检查不合格数",
  paymentInfo: "付款信息",
  dec: "12月",
  caseOne: "案例一",
  amountCollected: "收款金额(元)",
  malfunctionConfirmation: "故障确认",
  newPwd: "新密码",
  hourLineOnDuty: "24小时值班电话",
  remainingDays: "倒计天数",
  maintenanceLevel: "维保等级",
  codeIncorrect: "校验码不正确",
  onlineEmployees: "在线员工",
  illegalCharactersInKunNo: "昆山119编号含有非法字符",
  sendOrder: "派发工单",
  regionIOT: "物联网服务平台数据报表(区域)",
  doYouWantToAddParentElevators: "您确定添加父级所有电梯吗?",
  liNu: "证件号",
  sensorType: "传感器类型",
  humidity: "湿度",
  doorOpenOutput: "开门输出",
  manualQuotation: "人工报价",
  workingHours: "工单规定时长",
  fillInCode: "请填写手机校验码",
  elevatorList: "电梯列表",
  morePhone: "有多个用户同时使用该手机号",
  queryCompany: "安装公司查询",
  mild: "满意",
  dailyStandbyTime: "日均待命时间",
  personal: "个人",
  upDown: "上/下行",
  canceled: "因故取消",
  repairOrderTotal: "维修工单总数",
  driveMode: "驱动方式",
  messagePush: "短信推送",
  route: "轨迹",
  installationManagement: "安装合同管理",
  totalVehicleMilesTravelM: "车辆行使总里程数(保养)",
  roleName: "角色名称",
  currentFloor: "当前楼层",
  hoistingHeight: "提升高度",
  average: "平均值",
  editCollector: "编辑采集器",
  needQR: "您需要添加新的扫码位置",
  elevatorNoAlreadyExists: "电梯工号已存在",
  fillfailedInspectReason: "请务必填写核查不合格的原因",
  maintenanceStaffIOT: "物联网服务平台数据报表(维保员)",
  paymentDateIsNotRight: "付款日期不正确",
  forbidInfo: "已禁用",
  totalRecordsAfterText: "条数据",
  rescueTO: "困人平均解救耗时(分钟)",
  auditConfirmation: "资质审核确认",
  numberOfElevator: "电梯数量",
  sea: "搜索提供",
  emergencyRescue: "应急救援",
  newStaff: "新维保人员",
  newInstallStaff: "接受安装人员",
  search: "搜索",
  sNOne: "网点一",
  contractsExpiring: "保养合同到期列表",
  codeSignalGreater: "扫码标志必须为大于0的数字",
  onlineMaintenance: "在线维保",
  hotel: "宾馆酒店",
  deadline: "截止时间",
  obtainOrderPlan: "获取工单计划",
  roleAuthorization: "角色权限",
  companyManagement: "公司管理",
  sep: "9月",
  propertyCompany: "物业公司",
  enterCompanyType: "请填写公司类型",
  escalator: "扶梯",
  halfMonthUnits: "半月保总数",
  business: "业务",
  fillBrandName: "请填写品牌名称",
  column: "列",
  sellingS: "销售服务",
  elevatorStoppedOrNot: "是否停梯",
  abnormalDescription: "异常描述",
  tagNo: "标签号码",
  remould: "改造",
  ownerNickname: "业主简称",
  averageMaintenanceTimesByUnit: "台均保养次数",
  resetPwd: "重置密码",
  maintenanceContractManagement: "保养合同管理",
  maximum: "最大值",
  aging: "账龄(天)",
  completionStatus: "完成状态",
  freeToPaidMaintenance: "免保转有偿",
  newBillingRecord: "新增开票记录",
  quarter: "季度保养",
  goodOrderTotal: "良好评价总数",
  jul: "7月",
  equipmentNoAlreadyExists: "设备编号已存在",
  jun: "6月",
  dispatch: "已派发",
  orderNumber: "工单编号",
  codeLocExist: "扫码名称已存在",
  overIns: "自检超期",
  language: "zh-cn",
  liftOperation: "电梯实时运行状态",
  averageRepair: "平均修理(分钟)",
  equipmentContractNo: "设备号/合同号",
  breakdownReasonChart: "故障原因分析一览表",
  allOperation: "整体操作",
  allEmployees: "所有员工",
  elevatorExport: "电梯导入",
  generateBatch: "生成批次",
  totalUnqualifiedQDMC: "质量部自行维保检查总不合格数",
  yearEndM: "年度保养",
  enterCorrectNumber: "请填写有效的序号",
  enterRightPaymentAmount: "请填写正确的付款金额,格式:0.00",
  noEvaluation: "未评价",
  secondFaultLevel: "故障等级二级",
  subcontracting: "是否分包",
  newCollector: "新增采集器",
  oldNot: "旧密码不正确",
  propertyContract: "物业联系人",
  queryContract: "安装合同查询",
  collectorManage: "采集器管理",
  hoursMRO: "保养维修工时数",
  otherPremises: "其他场所",
  publicBuilding: "公共场馆",
  joyIOT: "巨立电梯物联网系统",
  monarchSystem: "默纳克系统",
  escalatorSystem: "扶梯系统",
  generalSystem: "通用系统",
  stepSystem: "新时达系统",
  cameraSystem: "摄像机系统",
  liftParameters: "电梯参数",
  month: "月份",
  aliasAlreadyExists: "使用位置已存在",
  fillInAI: "请务必填写年检有效期",
  dailyCompleteOrderNumbers: "日均完成工单",
  selectGroupLevel: "请选择小组层级",
  partialOperation: "部分操作",
  selectPerson: "请选择维保人员",
  invoicedAmount: "已开票金额(元)",
  back: "返回",
  addedSuccessfully: "已添加",
  gopageBeforeText: "&nbsp;转到",
  showRecordsFrom: "显示第",
  content: "内容",
  doYouWantToForbid: "您确定禁用吗?",
  expiringContractUnits: "即将到期合同(单位:台)",
  resetFailed: "重置密码失败",
  resetSuccess: "重置密码成功",
  ignore: "忽略",
  playback: "回放",
  company: "公司",
  parentGroup: "父级小组名称",
  trappedOrderTotal: "困人工单总数",
  unfinished: "未办结",
  otherLogo: "其他商标",
  callInCar: "内召",
  statisticsInfo: "以图表形式分析工单数量、类型、台量、维保人员信息等数据",
  enterEffectiveDate: "请填写合同生效日",
  pendingIssues: "电梯在线隐患统计表",
  maintenanceConfiguration: "维保配置",
  notice: "注意",
  projectAlias: "使用位置",
  theNumberOfTimesToDoNextHalfMonth: "即将第几次半月保养",
  illegalCharactersInElevatorNo: "电梯工号含有非法字符",
  singleElevatorUpkeepCost: "单台保养费(年)",
  durationGreaterThanZero: "合同时长(月)需大于零！",
  repairTotalUnits: "维修总台量",
  trappedOrNot: "是否困人",
  aboveInfo: "以上信息由",
  permission: "权限",
  systemRunningTime: "系统运行时间",
  userName: "用户名",
  companyWeb: "公司网站",
  pleaseFillPartyA: "请填写甲方公司",
  pleaseFillPartyB: "请填写乙方公司",
  qualifiedRateSMC: "自行维保检查合格率",
  businessCoop: "巨立云商务合作",
  resultMore: "搜索结果过多,请输入精确的查找条件",
  pleaseSelect: "请选择省/市/区",
  phoneNumberIncorrect: "电话格式不正确",
  signInAgain: "请重新登录",
  emptySearch: "请至少指定一个条件",
  selectElevators: "请选择应选电梯",
  generalFault: "一般故障",
  itemContent: "项次内容",
  select: "请选择",
  showRecordsToRecords: "条记录",
  userNameEx: "用户名已存在",
  companyName: "公司名称",
  consigneeNo: "收货联系电话",
  pFive: "产品五",
  repairUnits: "维修台量",
  qrCodeToll: "二维码",
  trappedOrder: "困人工单",
  maintenanceOrder: "保养工单",
  qrCodeGenerator: "生成二维码",
  quotationNo: "报价单号",
  payee: "收款人",
  accountsReceivable: "应收账款(元)",
  verySatisfied: "很满意",
  alreadyInspect: "已核查",
  staffInspectsData: "员工考核数据",
  getCode: "获取短信校验码",
  showRecordsTo: "到第",
  loadingData: "正在努力地加载，请稍候...",
  oct: "10月",
  transferUnits: "移交台数",
  fro: "来自",
  timeOfFault: "故障时间",
  confirmNewPwd: "确认新密码",
  chartAnalysis: "图表分析",
  malfunctionStatistics: "故障次数统计",
  orderExport: "导出工单",
  actualCompletionNumber: "实际完成总数",
  maintenancePerformed: "保养承接",
  applyAdvancedUser: "申请高级用户",
  fillInRec: "请务必上传整改单",
  maintenancePlanHasImported: "此维保计划已导入",
  tractionPassenger: "曳引驱动乘客电梯",
  howManyDayVerify: "完成所需天数必须在1-5之间",
  certification: "合格证",
  noRecord: "没有找到匹配的记录",
  selectMenu: "请先勾选此功能的上级菜单",
  aiUpdate: "年检更新",
  enterExpiryDate: "请填写合同到期日",
  notApproved: "审核不通过",
  trappedUnits: "困人台量",
  deleteGroupNo: "您无权限删除0级小组",
  currentMonthMaintenanceTimes: "本月保养次数",
  status: "状态",
  trappedRate: "困人率",
  onStandby: "待命",
  invoiceParty: "开票抬头",
  onlineInstallationInfo: "在线安装管理",
  saveAll: "保存全部",
  clientName: "客户名称",
  totalPrice: "报价总价",
  signingDate: "合同签订日",
  caseFour: "案例四",
  contactPerson: "公司联系人",
  errorInfo: "啊哦，您要查看的页面走丢了！",
  validateBeaconNo: "验证云盒编号",
  mainUnits: "保养台数",
  trappedTimes: "困人次数",
  maintenanceName: "保养名称",
  onlineNum: "在线台量",
  tips:"提示",
  todayFault: "实时故障",
  malfunction: "故障",
  newRenewalContract: "新增续签合同",
  qualityReport: "质量报告",
  malfunctionHandling: "故障处理",
  poorOrderTotal: "差评总数",
  repairOrder: "维修工单",
  statusSelection: "状态筛选",
  inspectResult: "核查结果",
  man: "负责人",
  componentReason: "部件原因",
  groupNameHas: "同级别中，该公司已存在相同小组名称.",
  malfunctionLifts: "发生故障的电梯，根据紧急情况和故障类型，会标示不同符号",
  mar: "3月",
  controlMode: "控制方式",
  repairTimes: "报修次数",
  nineNoAlreadyExists: "96333编号已存在",
  planType: "计划类型",
  may: "5月",
  staffData: "员工数据",
  elevatorManagement: "电梯管理",
  researchDebugging: "研发调试",
  suggestion: "建议",
  cylinderNum: "油缸数量",
  fillInCer: "请务必填写合格证",
  jackingType: "顶升型式",
  overhaulBilling: "大修开票",
  myFavorite: "我的收藏",
  userNameEm: "用户名不能为空",
  totalUnqualifiedNEMC: "新梯收梯维保检查总不合格数",
  codeLocation: "扫码位置",
  doorClose: "关门到位",
  eventStatus: "事件状态",
  hydraulicPassenger: "液压乘客电梯",
  report: "报表",
  ifYouCanNotFindIt: "如果您找不到它,点这个试试",
  nextPageText: "下一页",
  conscious: "自觉",
  mapLocation: "地图定位",
  contractManagement: "合同管理",
  unitsSMCIn: "部门内自行维保检查台量",
  chooseTakePictures: "请选择是否拍照",
  addedFailed: "添加失败",
  contractRemainingDays: "合同剩余天数",
  partsBilling: "配件开票",
  download: "下载",
  high: "高",
  monthlyPayment: "月付",
  host: "主机",
  staffMovement: "员工动向",
  invoiceNo: "发票号",
  invoiceType: "发票类型",
  amountMO: "维保工单数",
  serVio: "严重违规",
  enterElevatorNo: "请填写电梯工号",
  orCode: "组织机构代码",
  maintenanceOrderNumbers: "完成保养工单数量",
  newElevatorBrand: "新增电梯品牌",
  level: "等级",
  passwordEm: "密码不能为空",
  brandExists: "电梯品牌已存在",
  doYouWantToUpdate: "您确定更新吗?",
  qualifiedSMC: "自行维保检查合格数",
  totalQualifiedQDMC: "质量部维保检查总合格数",
  operationTime: "操作时间",
  stateDetection: "状态检测",
  billingDate: "开票日期",
  installationCompany: "安装公司",
  maintenancePlan: "电梯保养计划",
  allActions: "所有电梯的开关门动作、上下行、所在楼层等信息通过物联网采集并实时共享到平台，以动画的形式同步展现",
  allCategories: "所有分类",
  cityPlaceHolder: "例如：XX省XX市XX县/区XXX路",
  repairCompany: "改造、重大修理单位",
  updateInspectStatus: "更新核查状态",
  updatedSuccessfully: "已更新",
  tractionSteel: "曳引钢带家用电梯",
  fillLocation: "请填写扫码位置",
  no: "否",
  overdueReason: "超期理由",
  buttonTipAfterText: "页",
  searchCriteria: "搜索条件",
  fillContractNo: "请填写保养合同编号",
  workHours: "在岗时长",
  problemSolvingTroubleshooting: "问题解决和故障排除",
  ratedSpeed: "额定速度",
  recordWrong: ":数值错误，请检查开票记录有无错误",
  allLose: "整体丢失",
  totalVehicleMilesTravelT: "车辆行使总里程数(困人)",
  delete: "删除",
  fillInOldStaff: "请填写原维保人员",
  fillInStartTime: "请选择开始时间或结束时间",
  total: "工单总数",
  hydraulicFreight: "液压载货电梯",
  freeMaintenanceUnits: "免保台数",
  balancePayment: "有尾款",
  usedUnitNo: "使用单位内编号",
  salesOrderNo: "销售订单号",
  dearUser: "尊敬的用户,欢迎使用我们的产品",
  handover: "工作交接",
  lostType: "失信类型",
  CollectedAmountGreaterThan: "收款金额应大于0,格式:0.00",
  viewScheduler: "保养日程",
  averageMaintenanceTimeConsumingByUnit: "台均保养耗时(小时)",
  changePassword: "修改密码",
  otherStatus: "其他状态",
  repairTotalHours: "修理总工时(小时)",
  unitNoAlreadyExists: "使用单位内编号已存在",
  deliveryOrderNo: "出货单号",
  processed: "已处理",
  takePictures: "拍照",
  numberOfVideo:"视频数量",
  shootVideo:"视频",
  maintenanceRepair: "保养/抢修",
  allLost: "整体丢失",
  online: "在线",
  completionDate: "完成时间",
  inspectReasonChart: "工单不合格原因分析表",
  orderCategory: "工单类别",
  accountAmount: "到账总额",
  renewRecord: "续签记录",
  handler: "处理人员",
  InstallationSupervision: "安装监督",
  directSelling: "是否直销",
  debugOrNot:"是否调试",
  directSelling_yes: "直销",
  directSelling_no: "经销/代销" ,
  trappedUntreated: "困人未处理",
  currentYearBillingRevenue: "当年开票收入(元)",
  overloadSignal: "超载信号",
  aRescueTO: "总困人平均解救耗时(分钟)",
  idCard: "身份证",
  userNotExist: "用户不存在",
  faultLevel: "故障等级",
  realTimeStatus: "实时状态",
  currPageBeforeText: "当前第",
  province: "省",
  productConsultation: "产品咨询",
  selfMaintenanceUnitsPaid: "自行保养台量(有偿)",
  stateless: "无状态",
  lastModifyDate: "更新时间",
  anIn: "年检",
  selectMaintenanceStaff: "选择维保人员",
  inputInfo: "录入信息",
  inspectFailed: "更新核查失败",
  usernameDisabled: "账号已禁用",
  edit: "编辑",
  entrustUnits: "委托台数",
  hydraulicLadder: "液压梯",
  mall: "商场",
  enterStaffAccount: "请填写员工账号",
  equipmentNo: "平台档案号",
  partialLost: "部分丢失",
  workOrderProcess: "工单处理过程",
  machineRoomIntrusion: "机房入侵",
  submitItemTips: "请提交或取消待保存的内容",
  inServiceTime: "投用时间",
  maintenanceAccount: "维保账号管理",
  BillingDateIsNotRight: "开票日期不正确",
  receiptInfo: "收款信息",
  kunNoAlreadyExists: "昆山119编号已存在",
  unitsQDMC: "质量部维保检查台量",
  paidAmount: "已付款金额(元)",
  baseInfo: "基本信息",
  phoneEx: "手机号已存在",
  maintenancePerson: "维保人员",
  contractDuration: "合同时长(月)",
  noContractdata: "无相关合同数据，请重新输入",
  hideShowPagination: "隐藏/显示分页",
  latitude: "纬度",
  partsPerformed: "配件承接",
  distanceTimeConsumingForUrgentRepair: "抢修路程耗时(小时)",
  maintenanceContractPerson: "维保联系人",
  quarterlyUnits: "季度保总数",
  offline: "离线",
  sendTrappedOrder: "派发困人工单",
  current: "电流",
  enterPartyAB: "请填写甲方和乙方公司",
  duePaidMaintenance: "有偿到期",
  anySearch: "任意搜索",
  overdue: "逾期",
  renewManage: "续签管理",
  partialLose: "部分丢失",
  free: "免保",
  email: "电子邮箱",
  productNo: "产品编号",
  phoneNotEmpty: "请填写手机号",
  usernameUidNotExist: "用户名或者uid不存在",
  controller: "控制器",
  fillInNewStaff: "请填写新维保人员",
  middle: "中",
  userDoesNotExist: "不存在此用户",
  manager: "维保负责人",
  manMachineInteraction: "人机互动",
  noticeTips: "如果需要查询时间段内的工单，那么起始时间必须小于截止时间",
  blacklist: "黑名单公告",
  manufacturingCompany: "制造公司",
  sendMessage: "短信已成功推送",
  enterRightAmount: "请填写正确的合同金额,格式:0.00",
  numberSatisfactionEvaluation: "满意度评价总数",
  started: "已开始",
  statisticalStartDate: "统计开始日期",
  newReceiptInfo: "新增收款记录",
  maintenancePhone: "维保电话",
  systemSetting: "系统设定",
  confirm: "确定",
  connected: "已连接智能系统",
  satisfactionFive: "满意度(满分5分)",
  adverseType: "不良类型",
  groupWeb: "集团官网",
  to: "截至",
  disNotEmpty: "显示楼层不能为空",
  operation: "操作",
  officeBuilding: "办公综合",
  repairTimesByUnit: "报修率(次/台)",
  agent: "代理商",
  namePassWrong: "用户名或密码错误，请重新登录",
  equipmentNoShouldBeSix: "设备编号为6位数字",
  invoiceAmount: "开票金额(元)",
  completeRO: "维修工单完成数",
  sentMessageSuccessfully: "短信发送成功",
  expectedReceivableAgeAnalysis: "其中,预期应收账龄分析",
  initiateMaintenance: "发起维修",
  quarterlyPayment: "季付",
  createdOrderFailed: "创建工单失败",
  collectionDays: "收款日期",
  sectionLength: "使用区段长度",
  dailyMaintenance: "日常维修保养管理",
  moreThan3Months: "大于3个月",
  formerStaff: "原维保人员",
  formerInstallStaff: "移交安装人员",
  details: "详情",
  selectMaintenanceType: "请选择保养类型",
  outTerminalState: "主控板输出端子状态",
  totalTrappedTimes: "总困人次数",
  floorsInfo: "楼层信息",
  companyNameAlreadyExists: "该公司名称已存在",
  maintenanceBilling: "保养开票",
  query: "查询",
  billingInformation: "开票信息",
  disFloor: "显示楼层",
  partyA: "甲方公司",
  referenceRange: "参考范围",
  doorLockSignal: "门锁信号",
  failedToGetData: "获取数据失败",
  failure: "失败",
  notSynchronized: "未同步",
  partyB: "乙方公司",
  enterEquipmentNo: "请填写设备编号",
  inspect: "核查",
  regulator: "监管机构",
  unfinishedCFO: "用户评价未完成数",
  region: "区/县",
  updatedUnsuccessful: "更新失败",
  eleInfo: "电梯信息",
  lostDueFreeMaintenance: "免保到期丢失",
  requestExpired: "请求过期",
  records: " 条记录",
  notConnected: "未连接智能系统",
  completeTO: "困人工单完成数",
  update: "更新",
  repairRecord: "报修记录",
  onDuty: "在岗",
  averageMaintenanceUnitsByStaff: "人均保养台数",
  inTerminalState: "主控板输入端子状态",
  onlineInstallation: "在线安装",
  orderNumbers: "工单总数",
  unknownState: "未知状态",
  ownerName: "业主全称",
  roleNameCanNotEmpty: "角色名称不能为空",
  halfAYearUnits: "半年保总数",
  recordOperational: "记录操作过程",
  selectRole: "请选择角色",
  terminalOpenClose: "端子开闭",
  stationNot: "请填写正确的层站门,格式:10/10/10",
  callCenter: "呼叫中心",
  inspectStatistic: "工单合格率图",
  normal: "正常",
  photoEditor: "图片编辑",
  rescueTimeConsuming: "解救耗时(时/分)",
  doYouWantToDelete: "您确定删除吗?",
  voltage: "电压",
  doNotRevealToOthers: "请不要泄露给其他人",
  collectiveSelective: "集选",
  doYouWantToAdd: "您确定添加吗?",
  fillInStaff: "请填写维保人员",
  mainPower: "主机功率",
  inadequateAdjustment: "调整不到位",
  location: "位置",
  stationFormat: "格式:10/10/10",
  noInspect: "未核查",
  paymentDate: "付款日期",
  fileType: "文件类型",
  fileSize: "文件大小",
  fileInfo: "文件信息",
  templateType: "模板类型",
  userInfo: "用户信息",
  nodeOne: "节点一",
  endDate: "结束时间",
  contractType: "合同类型",
  protocolOfBrand: "品牌协议标识",
  none: "无",
  useOccasion: "使用场合",
  signUp: "注册",
  caseThree: "案例三",
  levelInfo: "该公司未得到电梯品牌信息，您无法添加维修等级。",
  yearEndUnits: "全年保总数",
  elevator: "直梯",
  supportStaff: "辅助人员",
  groupLevel: "小组层级",
  allRenew: "整体续签",
  receivedDate: "到款时间",
  checkOrder: "排查工单",
  untreated: "未处理",
  ignored: "已忽略",
  newFreeMaintenance: "免保新增",
  openDoorDelayBtn: "开门延时按钮",
  completeMO: "维保工单完成数",
  companyTEL: "公司热线",
  downCall: "下召",
  lumpSumPayment: "一次总付",
  deleteGroupCanNot: "您不能删除已使用的小组",
  caseStudy: "案例分析",
  semiyearlyPayment: "半年付",
  contractLost: "合同已全部丢失",
  rapidRescue: "迅速的网格救援服务",
  buttonTipBeforeText: "第",
  caseFive: "案例五",
  selectUrgentStaff: "请选择急修人员",
  contractSource: "合同来源",
  totalNEMC: "新梯收梯维保检查总台量",
  notStarted: "未开始",
  repairRO: "维修平均修理(分钟)",
  lastModifier: "更新人",
  layerStationDoor: "层/站/门",
  unitsStatistics: "台量统计数据",
  phoneNo: "手机号",
  basicInfo: "基础信息",
  nick: "姓名",
  totalUnqualifiedSMC: "自行维保检查总不合格数",
  anException: "出现异常",
  event: "事件",
  maintenanceTimes: "保养次数",
  totalUnitsNEMC: "新梯收梯维保检查台量",
  staffAccountExists: "员工账号已存在",
  sTimeBeforeEndTime: "开始时间必须小于结束时间",
  createDate: "创建日期",
  trappedOrderNumbers: "完成困人工单数量",
  qualifiedRateSMCIn: "部门内自行维保检查合格率",
  contractStatus: "合同状态",
  fillSubcontractCompany: "请填写分包公司",
  typicalCase: "典型案例",
  currentStatus: "当前状态",
  responseTime: "响应时间",
  materialQuotation: "材料报价",
  sendLater: "稍后派发(更新)",
  toggle: "切换",
  otherYear: "其他年度",
  PENDING: "待审查",
  caseNo: "备案号",
  workBillInfo: "工单信息",
  trappedAlarm: "困人警报",
  regulations: "法规宣传",
  WAITING: "待接受",
  faultDescription: "故障描述",
  runningState: "运行状态",
  gridRescue: "网格救援",
  connecting: "连接中...",
  uploadAttachment: "上传附件",
  fillUpdateContent: "请填写更新内容",
  minimum: "最小值",
  bstSystem: "贝思特系统",
  statusNormal: "电梯状态: 正常 ",
  date: "日期",
  averageMaintenanceTimesByStaff: "人均保养工时(小时)",
  performanceEvaluation: "业绩统计数据",
  abnormalCo: "通讯异常",
  checkYourAPP: "发生困人事件，请关注派单系统",
  userLock: "当前用户已锁定",
  spec: "规格",
  generalO: "通用",
  MondayFri: "周一至周五",
  from: "自",
  brandNo: "品牌编号",
  permissionNotExist: "不存在此权限",
  unaudited: "未审核",
  audited: "已审核",
  totalQualifiedSMCRate: "自行维保检查总合格率",
  brandName: "品牌名称",
  malfunctionConRecord: "故障确认记录",
  nineNo: "96333编号",
  eleFaultChart: "电梯故障情况一览表",
  rejectingTimes: "拒绝总数",
  unmaintained: "未维护",
  finished: "已完结",
  timespan: "时间间隔",
  beaconNoAlreadyExists: "云盒编号已存在",
  reassignFailed: "工单改派失败",
  SEND: "待派发",
  contractPeriod: "合同期限(年)",
  factoryDefault: "出厂默认值",
  serviceCall: "报障电话",
  faultTimesIgnored: "电梯故障次数(人工忽略)",
  person: "人员",
  sendImmediately: "立即派发",
  reconditionState: "检修状态",
  repair: "维修",
  terminalState: "端子状态",
  userManagement: "用户管理",
  roleDoesNotExist: "不存在此角色",
  anInSchedule: "年检管理一览表",
  batchUpdate: "批量更新",
  videoMonitor3: "3G视频监控",
  videoMonitor4: "4G视频监控",
  buildingUsingParty: "使用单位",
  malfunctionIndication: "故障提示",
  totalAmountTO: "总困人工单数",
  paymentAmount: "付款金额",
  newContract: "新增合同",
  passwordDiffer: "两次密码不一致,请重新输入",
  car: "轿厢",
  inUse: "在用",
  station: "维保站",
  elevatorType: "电梯品种",
  quotationPrice: "报价单价",
  countdownExpiryDate: "合同到期倒计时",
  value: "值",
  stationBuilding: "车站",
  qualifiedRateQDMC: "质量部自行维保检查合格率",
  pOne: "产品一",
  trappedTotalUnits: "困人总台量",
  finishedOrders: "完成总数",
  moduleType: "模块种类",
  difStaff: "原维保人员和新维保人员不能相同",
  doYouWantToImport: "您确定导入c盘下的计划表吗？",
  supportedTech: "技术支持内容",
  INHAND: "处理中",
  juliElevator: "巨立电梯股份有限公司",
  elevatorsData: "电梯档案信息表",
  closeDoorBtnShow: "关门按钮显示",
  doYouWantToSelectAll: "您确定全选添加吗?",
  noLatLng: "该电梯没有坐标",
  moreThan2Years: "大于2年",
  topLevelFirst: "请先添加0级小组",
  appFunction: "APP功能",
  pFour: "产品四",
  governmentBuilding: "政府部门",
  newWorkOrder: "新增工单",
  viewWorkOrder: "查看工单",
  input: "请输入",
  enable: "解禁",
  filter: "筛选",
  managerLevel2: "用户管理2级",
  managerLevel3: "用户管理3级",
  addUser: "添加用户",
  banUser: "禁用用户",
  editUser: "编辑用户",
  qrCodeTool: "二维码工具",
  addBlacklist: "添加黑名单",
  editBlacklist: "编辑黑名单",
  deleteBlacklist: "删除黑名单",
  addExposureEvent: "添加曝光事件",
  editExposureEvent: "编辑曝光事件",
  deleteExporeEvent: "删除曝光事件",
  APPMaintenanceModule: "APP维保模块",
  APPLiveDataModule: "APP实时数据模块",
  APPVideoMonitorModule: "APP视频监控模块",
  APPDataCalculationModule: "APP数据统计模块",
  staffLocation: "员工位置",
  workOrderCalculation: "工单统计",
  elevatorLocatioin: "电梯位置",
  removeElevatorBrand: "删除电梯品牌",
  deleteCollector: "删除采集器",
  onlineMonitoringLevel2: "远程监控2级",
  test: "测试",
  productDistributionSplitScreen: "产品分布分屏用",
  checkGridRescue: "查看网格救援",
  addRepairRecord: "新增报修记录",
  editRepairRecord: "编辑报修记录",
  deleteRepairRecord: "删除报修记录",
  annualInspectorLevel2: "年检管理2级",
  annualInspectorLevel3: "年检管理3级",
  annualInspectionDetail: "年检管理详情",
  addMaintenanceStaff: "添加维保人员",
  updateMaintenanceStaff: "编辑维保人员",
  deleteMaintenanceStaff: "删除维保人员",
  serviceCenterrReport: "服务中心报表",
  serviceLife_BreakDownTimeRelation: "使用年限与故障发生次数关系表",
  breakDownAnalyze: "故障分析原因",
  addMaintenanceItem: "新增维保项次",
  editMaintenanceItem: "编辑维保项次",
  deleteMaintenanceItem: "删除维保项次",
  maintenancePlan2: "维保计划",
  editBillingRecord: "编辑开票记录",
  deleteBillingRecord: "删除开票记录",
  exportBillingRecord: "导出开票记录",
  collectionRecord: "收款记录管理",
  editReceiptRecord: "编辑收款记录",
  deleteReceiptRecord: "删除收款记录",
  exportReceiptRecord: "导出收款记录",
  addLog: "添加日志",
  deleteLog: "删除日志",
  exportData: "导出数据",
  syncData: "同步数据",
  elevatorImport: "电梯导入",
  floorsInfoManagement: "楼层信息管理",
  removeElevator: "删除电梯",
  editElevator: "编辑电梯",
  addCompany: "添加公司",
  deleteCompany: "删除公司",
  editCompany: "编辑公司",
  contractImport: "导入合同",
  exportFinanceData: "导出财务数据",
  exportContract: "导出合同",
  editMaintenanceContract: "编辑保养合同",
  deleteMaintenanceContract: "删除保养合同",
  viewMaintenanceContract: "查看保养合同",
  addGroup: "添加小组",
  editGroup: "编辑小组",
  deleteGroup: "删除小组",
  editingAuditRescuersInfo: "编辑审核救援人员信息",
  breakdownReasonAnalysis: "故障原因分析",
  historicalRoute: "历史轨迹",
  addWorkOrder: "新增工单",
  workOrderInspect: "工单核查",
  deleteWorkOrder: "删除工单",
  exportPresentation: "导出报告",
  exportReport: "导出报表",
  exportPendingMatters: "导出未决事宜",
  deleteMaintenanceBatch: "删除维保批次",
  exportMaintenanceProgram: "导出维保计划",
  addMaintenancePlan: "添加维保计划",
  editMaintenancePlan: "编辑维保计划",
  deleteMaintenancePlan: "删除维保计划",
  viewMaintenanceSchedule: "查看保养日程",
  addRoles: "添加角色",
  editRole:"编辑角色",
  disableRole: "禁用角色",
  originalcontract: "合同原件",
  maintenancePlanInspect: "保养计划核查",
  EXAMINED: "已审查",
  custom: "自定义数据",
  Reason: "原因",
  maintainstatus: "维保状态",
  confirmsubmission: "确认提交",
  faultSetting: "故障推送设置",
  elevatorPushable:"电梯故障推送设置",
  faultpushstatusfunction: "故障推送状态功能",
  faultpush: "故障推送",
  pushon: "推送已开启",
  pushclosed: "推送已关闭",
  operationRecord: "弹窗操作记录",
  reportingtime: "上报时间",
  abbreviation: "简称",
  pushMessage: "消息推送",
  menuPermissions: "菜单权限",
  functionitempermission: "功能项权限",
  inspectResponseStatic: "维修工单响应合格率",
  ipcWarning:'报警信息',
  newNode: "新增节点",   
  nodeLibraryDeploy: "节点库配置",  
  nodeContent: "节点内容",   
  inExecution: "执行中", 
  dateOfSigning: "签订日期",  
  contacts: "联系人", 
  representativeA: "甲方代表人", 
  representativeB: "乙方代表人",  
  addressA: "甲方地址", 
  addressB: "乙方地址", 
  telephoneA: "甲方电话", 
  telephoneB: "乙方电话",  
  contractDetails: "安装合同详细",   
  projectAddress: "项目地址", 
  nodeTemplate: "节点模板",  
  elevatorInstall1: "在线安装", 
  installOperationNode: "节点模板库", 
  installWorkOrder: "安装工单管理",  
  installOrderDetail: "安装工单详情",  
  basicNodeConfig: "基础节点库配置",  
  auditor: "审核人员",
  newAuditor: "接受审核人员",
  oldAuditor: "移交审核人员",
  addInstallWorkOrder: "新增安装工单",
  deleteInstallWorkOrder: "删除安装工单",
  editInstallWorkOrder: "编辑安装工单",
  elevatorInstall: "安装管理",
  addNodeLibrary: "新增节点库",
  deleteNodeLibrary: "删除节点库",
  editNodeLibrary: "编辑节点库",
  APPInstallModule: "APP安装模块",
  auditInstallWorkOrder: "审核安装工单",
  addInstallContract: "新增安装合同",
  editInstallContract: "编辑安装合同",
  deleteInstallContract: "删除安装合同",
  editRegionAttribute: "编辑区域",
  deleteRegionAttribute: "删除区域",
  addRegionAttribute: "新增区域",
  noneFunction: "该电梯暂未开通此功能",
  auditOpinion: "审核意见",
  adopt: "通过",
  Failed1: "未通过",
  width: "宽度",
  height: "高度",
  qrCodeLength: "长度在 1 到 10 个字符",
  currentVoltage: "电流/电压",
  executive: "主管人员",
  receiver: "接收人",
  receivingMode: "接收方式",
  elementId: "elementId",
  samedayWorkBillStatistics: "当日工单统计",
  dataOverview2: "数据总览2",
  todayBillTotal: "今日工单总数",
  currentFinishBill: "当前已完成工单数",
  timeOutBill: "即将超时工单数",
  advertManage: "广告管理",
  programManage: "节目管理",
  matterList: "素材管理",
  deviceManage: "终端管理",
  programList: "节目列表",
  createProgram: "创建节目",
  packetProgram: "打包节目",
  packetProgramList: "打包节目列表",
  playPlan: "播放计划",
  deviceList: "终端列表",
  audit: "审核",
  preview: "预览",
  releaseProgram: "发布节目",
  device: "设备",
  available: "可用",
  unavailable: "不可用",
  toBeReviewed: "待审核",
  createdDate: "创建时间",
  programDuration: "节目时长",
  timeSlot: "播放时段",
  broadcastDate: "播放日期",
  homeScreen: "主屏",
  secondaryScreen: "副屏",
  playArea: "播放区域",
  batchDelete: "批量删除",
  batchAudit: "批量审核",
  refuse: "拒绝",
  programNotes: "节目备注",
  programName: "节目名称",
  chooseProgram: "请先选择节目！",
  chooseMatter: "请先选择文件！",
  previewAfterEdit: "您尚未编辑节目信息，请重新编辑后预览！",
  deviceName: "终端名称",
  deviceMAC: "终端MAC",
  deviceSN: "终端SN",
  organization: "所属组织",
  deviceDirection: "终端方向",
  horizontalScreen: "横屏",
  verticalScreen: "竖屏",
  programSize: "节目大小",
  programDirection: "节目方向",
  directionAdaptation: "方向适配",
  directionOnErrorTip: "您选择的终端方向适配不可用，请重新选择！",
  picture: "图片",
  document: "文档",
  turnOn: "开",
  turnOff: "关",
  volumn: "音量",
  faceRecognition: "人脸识别",
  doubleScreenSwitch: "双屏开关",
  workingHours: "工作时间",
  programDetails: "节目详情",
  unbundling: "解绑",
  exitPassword: "退出密码",
  deviceInfo: "终端信息",
  bindingTime: "绑定时间",
  registrationTime: "注册时间",
  IPAddress: "IP地址",
  screenInformation: "屏信息",
  deviceMemory: "设备内存",
  deviceStorage: "设备存储",
  versionInformation: "版本信息",
  firmwareVersion: "固件版本",
  applicationVersion: "应用版本",
  screenshot: "截图",
  standby: "待机",
  awaken: "唤醒",
  restart: "重启",
  adjustVolume: "调节音量",
  emptyProgram: "清空节目",
  partsManagement: "部件管理",
  partsMaintenance: "部件维护",
  queryOfProblemParts: "问题部件查询",
  rescueWorkers: "救援人员",
  partName: "部件名称",
  technicalReplacement: "更换技术条件",
  replacementCycle: "更换周期",
  monthly: "月",
  annually: "年",
  remarks: "备注",
  historicalUpdate: "历史更新",
  noHistoricalData: "暂无历史更新数据",
  updateDate: "更新日期",
  updateReason: "更新原因",
  addPart: "添加部件",
  selectPart: "请选择部件",
  qualitySupervisionBureau: "质监局",
  batchElevatorParts: "批量电梯部件管理",
  EUCRN: "设备使用证登记编号",
  batchAudit:"批量审核",
  AuditSignature:"审核签名",
  elevatorIP:"摄像头ID",
  videoURL:"视频URL",
  APPCustomModule:"APP客户模块",
  FunctionSelection:'功能选择',
  LightCurtain1:'光幕1',
  LightCurtain2:'光幕2',
  OpenTheDoorInPlace1:'开门到位1',
  OpenTheDoorInPlace2:'开门到位2',
  CloseTheDoorInPlace1:'关门到位1',
  CloseTheDoorInPlace2:'关门到位2',
  FullLoadSignal:'满载信号',
  OverloadSignal:'超载信号',
  DoorOpeningButton:'开门按钮',
  CloseDoorButton:'关门按钮',
  DoorOpeningDelayButton:'开门延时按钮',
  DriverSignal:'司机信号',
  ReversingSignal:'换向信号',
  IndependentOperationSignal:'独立运行信号',
  FirefighterOperationSignal:'消防员操作信号',
  DoorOpeningOutput1:'开门输出1',
  OutputWithTheDoorClosed1:'关门输出1',
  DoorLockSignal:'门锁信号',
  DoorOpeningOutput2:'开门输出2',
  OutputWithTheDoorClosed2:'关门输出2',
  MarkTheArrivalClock:'上到站钟标记',
  ReachTheStationClockMarker:'下到站钟标记',
  DisplayOfTheDoorOpeningButton:'开门按钮显示',
  TheCloseDoorButtonIsDisplayed:'关门按钮显示',
  TheDoorOpeningDelayButtonIsDisplayed:'开门延时按钮显示',
  NonGateAreaParkingOutput:'非门区停车输出',
  reserved: "保留",
  buzzerOutput: "蜂鸣器输出",
  EnergySavingMark:'节能标记',
  CurrentOrVoltage:'电流/电压',
  InputTerminalStatus:'输入端子状态',
  OutputTerminalStatus:'输出端子状态',
  TheInputStatusOfTheCarRoof:'轿顶输入状态',
  TheOutputStatusOfTheCarRoof:'轿顶输出状态',
  '上平层常开':'上平层常开',
'楼层':'Floor',
'运行方向':'Running direction',
'开关门状态':'Door open or close state',
'检修状态':'Service state',
'运行状态':'Normal state',
'供电中断':'NO power',
'电梯锁梯信号':'MCB locking lift',
'超速信号':'Over speed',
'电梯消防状态信号':'Fire signal',
'电梯门区信号':'Leveling position',
'电梯轿厢超载信号':'Overload signal',
'电梯轿厢满载信号':'Full load signal',
'电梯控制器有密码':'Password',
'电梯故障代码':'Error code',
'电梯故障子码':'Error sub-code',
'厂家编号':'DB',
'运行速度':'Running speed',
'电流':'Current',
'电压':'Voltage',
'上平层':'Upper level',
'下平层':'Lower level',
'门区':'Leveling position',
'安全回路反馈':'Safety circuit feedback',
'门锁回路反馈':'Door and lock closed feedback',
'运行接触器反馈':'Motor contactor feedback',
'抱闸反馈':'Brake contactor feedback',
'检修信号':'Service signal',
'检修/紧急电动上行':'Service up driving signal',
'检修/紧急电动下行':'Service down driving signal',
'消防信号':'Fire signal',
'上限位':'Up limit signal',
'下限位':'Down limit signal',
'超载':'Overload signal',
'满载':'Full load signal',
'门1光幕':'Light curtain 1',
'门2光幕':'Light curtain 2',
'抱闸行程开关1反馈':'Brake position feedback 1',
'停电应急运行':'ARD',
'锁梯':'Lift locked',
'安全回路2反馈':'Safety circuit 2 feedback',
'门锁回路2反馈':'Door and lock 2 closed feedback',
'门1安全触板反馈':'Door 1 Safety circuit feedback',
'门2安全触板反馈':'Door 2 Safety circuit feedback',
'电机过热':'Motor overheated',
'地震信号':'Earthquake signal',
'轻载':'Light load',
'半载':'Half load',
'消防基站切换':'Alternative fire escape floor enable',
'门1开门输入':'Door 1 open input',
'门2开门输入':'Door 2 open input',
'报闸行程开关2反馈':'Brake position feedback 2',
'外部故障输入':'External fault input signal',
'门锁1短接':'Door lock 1 connect',
'门锁2短接':'Door lock 2 connect',
'紧急电动':'Emergency evacuation',
'抱闸电机脉冲输入':'Pulse capture 1',
'抱闸微动开关1':'Brake position feedback 1',
'抱闸微动开关2':'Brake position feedback 2',
'轿顶撑杆开关':'Top prop position contactor',
'浸水信号':'Water sensor signal',
'安全回路信号':'Safety circuit signal',
'门锁回路信号1':'Door and lock closed signal 1',
'门锁回路信号2':'Door and lock closed signal 2',
'门锁1短接':'Door lock 1 connect',
'门锁2短接':'Door lock 2 connect',
'运行接触器':'Motor contactor output',
'抱闸接触器':'Brake contactor output',
'消防到基站':'Alternative fire escape floor',
'门机1开门':'Open door signal 1 output',
'门机1关门':'Close door signal 1 output',
'门机2开门':'Open door signal 2 output',
'门机2关门':'Close door signal 2 output',
'抱闸/运行接触器正常':'Brake /Motor contactor ok',
'故障状态':'Error',
'运行状态':'Elevator running status',
'救援自动切换':'ARD mode enable',
'救援蜂鸣提示':'Buzzer sounds when leveling in evacuation',
'上行信号':'Upwards running signal',
'照明风扇运行':'Lamp output signal',
'非门区停车':'Stop without leveling',
'电锁控制':'Electric lock output signal',
'非服务状态提示':'Lift cannot be used',
'救援运行完成输出':'Evacuation completed',
'抱闸电机正转输出':'Brake motor CW output',
'抱闸电机反转输出':'Brake motor CCW output',
'运行接触器':'Motor contactor output',
'抱闸接触器':'Brake contactor output',
'光幕1':'Light curtain 1',
'光幕2':'Light curtain 2',
'开门到位1':'Door open limit 1',
'开门到位2':'Door open limit 2',
'关门到位1':'Door close limit 1',
'关门到位2':'Door close limit 2',
'满载信号':'Full load signal input',
'超载信号':'Over load',
'开门按钮':'Open door button',
'关门按钮':'Close door button',
'开门延时按钮':'Bit2: Reserved',
'直达信号':'Direct arrival mode signal input',
'司机信号':'Driver mode signal input',
'换向信号':'Direction change signal input',
'消防员操作信号':'Fire input signal',
'平台急停':'Emergency button no trigger',
'安全边1':'Safe edge 1 no trigger',
'安全边2':'Safe edge 2 no trigger',
'安全边3':'Safe handle no trigger',
'超载':'Overload signal',
'轿内IC卡':'IC card signal',
'安装模式检修':'Installation mode',
'锁梯':'Lift locked',
'消防':'Fire signal',
'地震':'Earthquake signal',
'UPS接入':'UPS input',
'紧急电动':'Normal mode signal from EOB',
'紧急电动上行':'Up signal from EOB',
'紧急电动下行':'Down signal from EOB',
'故障复位':'Reset signal from extra button',
'自动门前门开门到位':'Auto doors of LDCB 1-8 opened',
'自动门中门开门到位':'Auto doors of LDCB 9-16 opened',
'自动门后门开门到位':'Auto doors of LDCB 17-24 opened',
'自动门前门关门到位':'Auto doors of LDCB 1-8 closed',
'自动门中门关门到位':'Auto doors of LDCB 9-16 closed',
'自动门后门关门到位':'Auto doors of LDCB 17-24 closed',
'前门闭门触点有效':'Door closed contactors of LDCB 1-8',
'中门闭门触点有效':'Door closed contactors of LDCB 9-16',
'后门闭门触点有效':'Door closed contactors of LDCB 17-24',
'前门闭锁触点有效':'Lock closed contactors of LDCB 1-8',
'中门闭锁触点有效':'Lock closed contactors of LDCB 9-16',
'后门闭锁触点有效':'Lock closed contactors of LDCB 17-24',
'门锁末端':'End of circuit for doors and locks',
'安全末端':'End of safety circuit',
'开门输出1':'Auto door open 1',
'关门输出1':'Auto door close 1',
'门锁信号':'Door and lock  signal',
'开门输出2':'Auto door open 2',
'关门输出2':'Auto door close 2',
'门锁信号':'Door and lock  signal',
'开门按钮显示':'Open door button display',
'关门按钮显示':'Close door button display',
'开门延时按钮显示':'Delay Open door button display',
'非门区停车输出':'Stop without leveling',
'蜂鸣器输出':'Buzzer output',
'前门电锁输出':'Lock of LDCB 1-8 open',
'中门电锁输出':'Lock of LDCB 9-16 open',
'后门电锁输出':'Lock of LDCB 17-24 OPEN',
'自动开门器前门开门':'Auto door of LDCB 1-8 open',
'自动开门器中门开门':'Auto door of LDCB 9-16 open',
'自动开门器后门开门':'Auto door of LDCB 17-24 open',
'自动开门器前门关门':'Auto door of LDCB 1-8 close',
'自动开门器中门关门':'Auto door of LDCB 9-16 close',
'自动开门器后门关门':'Auto door of LDCB 17-24 close',
'系统运行时间':'Cumulative running time',
'运行次数':'Cumulative run times',
'控制方式':'Control mode',
'命令源选择':'Command source',
'面板运行速度':'Speed controlled by operation',
'运行速度':'Running speed',
'额定速度':'Rated speed',
'额定载重':'Rated load',
'最大频率':'Max frequency',
'载波频率':'Carrier frequency',
'编码器类型选择':'Encoder type',
'额定功率':'Rated power',
'额定电压':'Rated voltage',
'额定电流':'Rated current',
'额定频率':'Rated frequency',
'额定转速':'Rated rotating speed',
'同步机初始角度':'Syn. Encoder initial angle',
'同步机断电角度':'Syn. Encoder power off angle',
'同步机接线方式':'Syn. Wiring mode',
'编码器脉冲数':'Encoder pluses counts',
'断线检测时间':'Encoder wiring detection time',
'异步机定子电阻':'Stator resistance',
'异步机转子电阻':'Rotor resistance',
'异步机漏感抗':'Leakage inductance',
'异步机互感抗':'Mutual inductance',
'异步机空载电流':'Magnetizing current',
'Q轴电感(转矩)':'Axis Q inductance',
'D轴电感(励磁)':'Axis D inducatance',
'反电动势系数':'BEMF coefficient',
'驱动程序选择1':'Driver settings 1',
'驱动程序选择2':'Driver settings 2',
'电动机类型':'Motor type',
'速度环比例增益1':'Speed loop Kp 1',
'速度环积分时间1':'Speed loop Ti 1',
'切换频率1':'Shift frequency 1',
'速度环比例增益2':'Speed loop Kp 2',
'速度环积分时间2':'Speed loop Ti 2',
'切换频率2':'Shift frequency 2',
'电流比例增益':'Current loop Kp',
'电流积分增益':'Current loop Ti',
'转矩上限':'Torque upper limit',
'电梯运行方向':'Elevator running direction',
'零伺服电流系数':'Current coefficient at hold',
'零伺服速度环KP':'Speed loop Kp at hold',
'零伺服速度环TI':'Speed loop Ti at hold',
'力矩加速时间':'Torque acc time',
'力矩减速时间':'Torque dec time',
'保留':'Startup speed',
'减速比':'Reduction ratio',
'程序控制字3':'Program control word 3',
'优化的零伺服位置环增益KP':'Position loop Kp at hold',
'优化的零伺服位置环增益KI':'Position loop Ti at hold',
'性能调测参数1':'Performance commissioning parameter 1',
'性能调测参数2':'Performance commissioning parameter 2',
'性能调测参数3':'Performance commissioning parameter 3',
'性能调测参数4':'Performance commissioning parameter 4',
'性能调测参数5':'Performance commissioning parameter 5',
'性能调测参数6':'Performance commissioning parameter 6',
'性能调测参数7':'Performance commissioning parameter 7',
'性能调测参数8':'Performance commissioning parameter 8',
'性能调测参数9':'Performance commissioning parameter 9',
'调谐保留参数1':'Tuning preserves parameter 1',
'调谐保留参数2':'Tuning preserves parameter 2',
'调谐保留参数3':'Tuning preserves parameter 3',
'调谐保留参数4':'Tuning preserves parameter 4',
'启动速度':'Startup speed',
'启动速度保持时间':'Startup holding time',
'加速度':'Acc rate',
'加速开始段':'Time to increase acc value',
'加速结束段':'Time to decrease acc value',
'减速度':'Dec rate',
'减速结束段':'Time to increase dec value',
'减速开始段':'Time to decrease dec value',
'特殊减速度':'Special dec rate',
'停车距离裕量':'Pre-deceleration distance',
'检修运行速度':'Inspection speed',
'曲线运行延迟时间':'Delay time before moving',
'结束运行延迟时间':'Holding time after moving',
'低速返平层速度':'Re-leveling speed',
'救援加速度':'Acc rate of emergency running',
'强减延迟减速时间':'Dec delay of slow-down switch',
'紧急电动运行速度':'Speed of emergency running',
'井道自学习速度':'Speed of shaft measure',
'平层调整':'Leveling adjustment',
'当前层楼':'Current floor',
'电梯当前位置高位':'H-byte of current position',
'电梯当前位置低位':'L-byte of current position',
'平层插板长度1':'Length of leveling contact 1',
'平层插板长度2':'Length of leveling contact 2',
'层高1高位':'H-byte of F1 pulses',
'层高1低位':'L-byte of F1 pulses',
'层高2高位':'H-byte of F2 pulses',
'层高2低位':'L-byte of F2 pulses',
'层高3高位':'H-byte of F3 pulses',
'层高3低位':'L-byte of F3 pulses',
'层高4高位':'H-byte of F4 pulses',
'层高4低位':'L-byte of F4 pulses',
'层高5高位':'H-byte of F5 pulses',
'层高5低位':'L-byte of F5 pulses',
'层高6高位':'H-byte of F6 pulses',
'层高6低位':'L-byte of F6 pulses',
'层高7高位':'H-byte of F7 pulses',
'层高7低位':'L-byte of F7 pulses',
'层高8高位':'H-byte of F8 pulses',
'层高8低位':'L-byte of F8 pulses',
'层高9高位':'H-byte of F9 pulses',
'层高9低位':'L-byte of F9 pulses',
'层高10高位':'H-byte of F10 pulses',
'层高10低位':'L-byte of F10 pulses',
'层高11高位':'H-byte of F11 pulses',
'层高11低位':'L-byte of F11 pulses',
'层高12高位':'H-byte of F12 pulses',
'层高12低位':'L-byte of F12 pulses',
'层高13高位':'H-byte of F13 pulses',
'层高13低位':'L-byte of F13 pulses',
'层高14高位':'H-byte of F14 pulses',
'层高14低位':'L-byte of F14 pulses',
'层高15高位':'H-byte of F15 pulses',
'层高15低位':'L-byte of F15 pulses',
'层高16高位':'H-byte of F16 pulses',
'层高16低位':'L-byte of F16 pulses',
'层高17高位':'H-byte of F17 pulses',
'层高17低位':'L-byte of F17 pulses',
'层高18高位':'H-byte of F18 pulses',
'层高18低位':'L-byte of F18 pulses',
'层高19高位':'H-byte of F19 pulses',
'层高19低位':'L-byte of F19 pulses',
'层高20高位':'H-byte of F20 pulses',
'层高20低位':'L-byte of F20 pulses',
'层高21高位':'H-byte of F21 pulses',
'层高21低位':'L-byte of F21 pulses',
'层高22高位':'H-byte of F22 pulses',
'层高22低位':'L-byte of F22 pulses',
'层高23低位':'H-byte of F23 pulses',
'层高23低位':'L-byte of F23 pulses',
'层高24高位':'H-byte of F24 pulses',
'层高24低位':'L-byte of F24 pulses',
'层高25高位':'H-byte of F25 pulses',
'层高25低位':'L-byte of F25 pulses',
'层高26高位':'H-byte of F26 pulses',
'层高26低位':'L-byte of F26 pulses',
'层高27高位':'H-byte of F27 pulses',
'层高27低位':'L-byte of F27 pulses',
'层高28高位':'H-byte of F28 pulses',
'层高28低位':'L-byte of F28 pulses',
'层高29高位':'H-byte of F29 pulses',
'层高29低位':'L-byte of F29 pulses',
'层高30高位':'H-byte of F30 pulses',
'层高30低位':'L-byte of F30 pulses',
'层高31高位':'H-byte of F31 pulses',
'层高31低位':'L-byte of F31 pulses',
'层高32高位':'H-byte of F32 pulses',
'层高32低位':'L-byte of F32 pulses',
'层高33低位':'H-byte of F33 pulses',
'层高33低位':'L-byte of F33 pulses',
'层高34高位':'H-byte of F34 pulses',
'层高34低位':'L-byte of F34 pulses',
'层高35高位':'H-byte of F35 pulses',
'层高35低位':'L-byte of F35 pulses',
'层高36高位':'H-byte of F36 pulses',
'层高36低位':'L-byte of F36 pulses',
'层高37高位':'H-byte of F37 pulses',
'层高37低位':'L-byte of F37 pulses',
'层高38低位':'H-byte of F38 pulses',
'层高38低位':'L-byte of F38 pulses',
'层高39高位':'H-byte of F39 pulses',
'层高39低位':'L-byte of F39 pulses',
'X1功能选择':'X1 function selection',
'X2功能选择':'X2 function selection',
'X3功能选择':'X3 function selection',
'X4功能选择':'X4 function selection',
'X5功能选择':'X5 function selection',
'X6功能选择':'X6 function selection',
'X7功能选择':'X7 function selection',
'X8功能选择':'X8 function selection',
'X9功能选择':'X9 function selection',
'X10功能选择':'X10 function selection',
'X11功能选择':'X11 function selection',
'X12功能选择':'X12 function selection',
'X13功能选择':'X13 function selection',
'X14功能选择':'X14 function selection',
'X15功能选择':'X15 function selection',
'X16功能选择':'X16 function selection',
'X17功能选择':'X17 function selection',
'X18功能选择':'X18 function selection',
'X19功能选择':'X19 function selection',
'X20功能选择':'X20 function selection',
'X21功能选择':'X21 function selection',
'X22功能选择':'X22 function selection',
'X23功能选择':'X23 function selection',
'X24功能选择':'X24 function selection',
'Y1功能选择':'Y1 function selection',
'Y2功能选择':'Y2 function selection',
'Y3功能选择':'Y3 function selection',
'Y4功能选择':'Y4 function selection',
'Y5功能选择':'Y5 function selection',
'Y6功能选择':'Y6 function selection',
'通讯状态':'Communication state',
'程序控制选择':'Function selection bit',
'端子状态显示':'Terminal status display',
'端子状态显示':'Terminal status display',
'X25功能选择':'X25 function selection',
'X26功能选择':'X26 function selection',
'X27功能选择':'X27 function selection',
'X28功能选择':'X28 function selection',
'电梯最高层':'Top floor of lift',
'电梯最低层':'Bottom floor of lift',
'泊梯基站':'Parking floor when idle',
'消防基站':'Fire escape floor',
'锁梯基站':'Parking floor when locked',
'服务层1':'Service floor 1',
'服务层2':'Service floor 2',
'电梯编号':'LIFT DB',
'程序选择':'Function selection',
'电梯功能选择':'Function selection bit',
'VIP层':'VIP floor',
'锁梯开始时间':'Locking start time',
'锁梯结束时间':'Locking end time',
'程序控制选择1':'Function 1 selection bit',
'程序控制选择2':'Function 2 selection bit',
'程序控制选择3':'Function 3 selection bit',
'司机功能选择':'Drive function selection',
'消防功能选择':'Fire function selection',
'救援功能选择':'Evacuation function selection',
'VIP功能选择':'VIP function selection',
'闪烁提前时间':'Advance blink time',
'应急切换速度':'Evacuation shift speed',
'救援停靠基站':'Evacuation parking floor',
'静态电流':'Static current',
'程序功能选择':'Function selection bit',
'内召唤登记':'Simulated car call floor number',
'外召上登记':'Up call simulated floor number',
'外召下登记':'Down call simulated floor number',
'随机运行次数':'Random running test times',
'外召使能':'Hall call forbidden',
'开门使能':'Door open forbidden',
'超载使能':'Allow overload running',
'限位使能':'Limit switch forbidden',
'随机运行间隔':'Time interval of random running',
'停电应急救援速度':'ARD mode speed',
'停电应急援救选择':'ARD power supply from',
'停车力矩输出延时':'Brake apply delay',
'消防基站2':'Alternative fire escape floor',
'时钟：年':'Clock: year',
'时钟：月':'Clock: month',
'时钟：日':'ClocK: day',
'时钟：小时':'Clock: hour',
'时钟：分钟':'Clock: minute',
'累积运行时间':'Cumulative running time',
'运行次数高位':'H-byte of cumulative run times',
'运行次数低位':'L-byte of cumulative run times',
'维保天数设置':'Days limit for maintenance',
'软件版本(ZK)':'MCB software version',
'软件版本(DSP)':'Motor driver main version',
'散热器温度':'Driver temperature',
'预转矩电流':'Pre-torque current',
'逻辑信息':'Logic information',
'曲线信息':'Curve information',
'设定速度':'Set speed',
'反馈速度':'Feedback speed',
'母线电压':'Busbar voltage',
'当前位置':'Present position',
'输出电流':'Output current',
'输出频率':'Output frequency',
'转矩电流':'Torque current',
'输出电压':'Output voltage',
'输出转矩':'Output torque',
'输出功率':'Output power',
'通讯干扰':'Communication interference',
'编码器干扰':'Encoder interference',
'输入状态1':'Input state 1',
'输入状态2':'Input state 2',
'输入状态3':'Input state 3',
'输入状态4':'Input state 4',
'输入状态5':'Input state 5',
'输出状态1':'Output state 1',
'输出状态2':'Output state 2',
'轿厢输入状态':'Car input state',
'轿厢输出状态':'Car output state',
'厅外状态':'Hall state',
'系统状态1':'System state 1',
'系统状态2':'System state 2',
'最大楼层运行时间间隔':'Max running time between floors',
'主板软件临时版本':'MCB temporary version',
'主板软件厂家版本':'MCB manufacturer version',
'输入状态6':'Input state 6',
'输入状态7':'Input state 7',
'输出状态3':'Output state 3',
'输出状态4':'Output state 4',
'版本号显示选择':'Expansion version display selection',
'软件版本号':'Expansion board software version',
'软件临时版本号':'Expansion board temporary version',
'软件厂家版本号':'Expansion board manufacturer version',
'轿顶板临时版本号':'Top board temporary version',
'轿顶板厂家版本号':'Top board manufacturer version',
'功能规范版本':'Functional specification Version',
'门机数量':'Number of doors per floor',
'轿顶板软件版本':'CTB software version',
'门机1服务层1':'Door 1 service floor1',
'门机1服务层2':'Door 1 service floor2',
'门机2服务层1':'Door 2 service floor1',
'门机2服务层2':'Door 2 service floor2',
'开门时间保护':'Open door times limit',
'到站钟输出延时':'Dong output delay time',
'关门时间保护':'Close door times limit',
'关门/开门次数':'Close/open door NO.',
'待梯门状态':'Door state during standby',
'外招开门保持':'Open hold time of hall call',
'内招开门保持':'Open hold time of car call',
'基站开门保持':'Open hold time of pariking floor',
'程序控制选择':'Protection function selection 1',
'功能选择':'Protection function selection 2',
'过载保护系数':'Overload protection coefficient',
'过载预警系数':'Overload pre-warning coefficient',
'贯通门功能选择':'Opposite door selection',
'第1次故障':'1st error code',
'第1次子码':'1st curve error subcode',
'第1次月日':'1st error occur month and day',
'第1次时间':'1st error occur time',
'第2次故障':'2nd error code',
'第2次子码':'2nd curve error subcode',
'第2次月日':'2nd error occur month and day',
'第2次时间':'2nd error occur time',
'第3次故障':'3rd error code',
'第3次子码':'3rd curve error subcode',
'第3次月日':'3rd error occur month and day',
'第3次时间':'3rd error occur time',
'第4次故障':'4th error code',
'第4次子码':'4th curve error subcode',
'第4次月日':'4th error occur month and day',
'第4次时间':'4th error occur time',
'第5次故障':'5th error code',
'第5次子码':'5th curve error subcode',
'第5次月日':'5th error occur month and day',
'第5次时间':'5th error occur time',
'第6次故障':'6th error code',
'第6次子码':'6th curve error subcode',
'第6次月日':'6th error occur month and day',
'第6次时间':'6th error occur time',
'第7次故障':'7th error code',
'第7次子码':'7th curve error subcode',
'第7次月日':'7th error occur month and day',
'第7次时间':'7th error occur time',
'第8次故障':'8th error code',
'第8次子码':'8th curve error subcode',
'第8次月日':'8th error occur month and day',
'第8次时间':'8th error occur time',
'第9次故障':'9th error code',
'第9次子码':'9th curve error subcode',
'第9次月日':'9th error occur month and day',
'第9次时间':'9th error occur time',
'第10次故障':'10th error code',
'第10次子码':'10th curve error subcode',
'第10次月日':'10th error occur month and day',
'第10次时间':'10th error occur time',
'第11次故障':'11th error code',
'第11次子码':'11th curve error subcode',
'第11次月日':'11th error occur month and day',
'第11次时间':'11th error occur time',
'第12次故障':'12th error code',
'第12次子码':'12th curve error subcode',
'第12次月日':'12th error occur month and day',
'第12次时间':'12th error occur time',
'第13次故障':'13th error code',
'第13次子码':'13th curve error subcode',
'第13次月日':'13th error occur month and day',
'第13次时间':'13th error occur time',
'第14次故障':'14th error code',
'第14次子码':'14th curve error subcode',
'第14次月日':'14th error occur month and day',
'第14次时间':'14th error occur time',
'第15次故障':'15th error code',
'第15次子码':'15th curve error subcode',
'第15次月日':'15th error occur month and day',
'第15次时间':'15th error occur time',
'第16次故障':'16th error code',
'第16次子码':'16th curve error subcode',
'第16次月日':'16th error occur month and day',
'第16次时间':'16th error occur time',
'第17次故障':'17th error code',
'第17次子码':'17th curve error subcode',
'第17次月日':'17th error occur month and day',
'第17次时间':'17th error occur time',
'第18次故障':'18th error code',
'第18次子码':'18th curve error subcode',
'第18次月日':'18th error occur month and day',
'第18次时间':'18th error occur time',
'第19次故障':'19th error code',
'第19次子码':'19th curve error subcode',
'第19次月日':'19th error occur month and day',
'第19次时间':'19th error occur time',
'第20次故障':'20th error code',
'第20次子码':'20th curve error subcode',
'第20次月日':'20th error occur month and day',
'第20次时间':'20th error occur time',
'第21次故障':'21st error code',
'第21次子码':'21st curve error subcode',
'第21次月日':'21st error occur month and day',
'第21次时间':'21st error occur time',
'第22次故障':'22nd error code',
'第22次子码':'22nd curve error subcode',
'第22次月日':'22nd error occur month and day',
'第22次时间':'22nd error occur time',
'第23次故障':'23rd error code',
'第23次子码':'23rd curve error subcode',
'第23次月日':'23rd error occur month and day',
'第23次时间':'23rd error occur time',
'第24次故障':'24th error code',
'第24次子码':'24th curve error subcode',
'第24次月日':'24th error occur month and day',
'第24次时间':'24th error occur time',
'第25次故障':'25th error code',
'第25次子码':'25th curve error subcode',
'第25次月日':'25th error occur month and day',
'第25次时间':'25th error occur time',
'第26次故障':'26th error code',
'第26次子码':'26th curve error subcode',
'第26次月日':'26th error occur month and day',
'第26次时间':'26th error occur time',
'第27次故障':'27th error code',
'第27次子码':'27th curve error subcode',
'第27次月日':'27th error occur month and day',
'第27次时间':'27th error occur time',
'第28次故障':'28th error code',
'第28次子码':'28th curve error subcode',
'第28次月日':'28th error occur month and day',
'第28次时间':'28th error occur time',
'第29次故障':'29th error code',
'第29次子码':'29th curve error subcode',
'第29次月日':'29th error occur month and day',
'第29次时间':'29th error occur time',
'第30次故障':'30th error code',
'第30次子码':'30th curve error subcode',
'第30次月日':'30th error occur month and day',
'第30次时间':'30th error occur time',
'第31次故障':'31st error code',
'第31次子码':'31st curve error subcode',
'第31次月日':'31st error occur month and day',
'第31次时间':'31st error occur time',
'第32次故障':'32nd error code',
'第32次子码':'32nd curve error subcode',
'第32次月日':'32nd error occur month and day',
'第32次时间':'32nd error occur time',
'第33次故障':'33rd error code',
'第33次子码':'33rd curve error subcode',
'第33次月日':'33rd error occur month and day',
'第33次时间':'33rd error occur time',
'第34次故障':'34th error code',
'第34次子码':'34th curve error subcode',
'第34次月日':'34th error occur month and day',
'第34次时间':'34th error occur time',
'第35次故障':'35th error code',
'第35次子码':'35th curve error subcode',
'第35次月日':'35th error occur month and day',
'第35次时间':'35th error occur time',
'第36次故障':'36th error code',
'第36次子码':'36th curve error subcode',
'第36次月日':'36th error occur month and day',
'第36次时间':'36th error occur time',
'第37次故障':'37th error code',
'第37次子码':'37th curve error subcode',
'第37次月日':'37th error occur month and day',
'第37次时间':'37th error occur time',
'第38次故障':'38th error code',
'第38次子码':'38th curve error subcode',
'第38次月日':'38th error occur month and day',
'第38次时间':'38th error occur time',
'第39次故障':'39th error code',
'第39次子码':'39th curve error subcode',
'第39次月日':'39th error occur month and day',
'第39次时间':'39th error occur time',
'第40次故障':'40th error code',
'第40次子码':'40th curve error subcode',
'第40次月日':'40th error occur month and day',
'第40次时间':'40th error occur time',
'第41次故障':'41st error code',
'第41次子码':'41st curve error subcode',
'第41次月日':'41st error occur month and day',
'第41次时间':'41st error occur time',
'第42次故障':'42nd error code',
'第42次子码':'42nd curve error subcode',
'第42次月日':'42nd error occur month and day',
'第42次时间':'42nd error occur time',
'第43次故障':'43rd error code',
'第43次子码':'43rd curve error subcode',
'第43次月日':'43rd error occur month and day',
'第43次时间':'43rd error occur time',
'第44次故障':'44th error code',
'第44次子码':'44th curve error subcode',
'第44次月日':'44th error occur month and day',
'第44次时间':'44th error occur time',
'第45次故障':'45th error code',
'第45次子码':'45th curve error subcode',
'第45次月日':'45th error occur month and day',
'第45次时间':'45th error occur time',
'第46次故障':'46th error code',
'第46次子码':'46th curve error subcode',
'第46次月日':'46th error occur month and day',
'第46次时间':'46th error occur time',
'第47次故障':'47th error code',
'第47次子码':'47th curve error subcode',
'第47次月日':'47th error occur month and day',
'第47次时间':'47th error occur time',
'第48次故障':'48th error code',
'第48次子码':'48th curve error subcode',
'第48次月日':'48th error occur month and day',
'第48次时间':'48th error occur time',
'第49次故障':'49th error code',
'第49次子码':'49th curve error subcode',
'第49次月日':'49th error occur month and day',
'第49次时间':'49th error occur time',
'第50次故障':'50th error code',
'第50次子码':'50th curve error subcode',
'第50次月日':'50th error occur month and day',
'第50次时间':'50th error occur time',
'HCB-JP1输入选择':'HCB-JP1 input selection',
'HCB-JP2输入选择':'HCB-JP2 input selection',
'HCB-JP1输出选择':'HCB-JP1 output selection',
'HCB-JP2输出选择':'HCB-JP2 output selection',
'扩展1输入X1输入':'Expansion board 1 X1 input',
'扩展1输入X2输入':'Expansion board 1 X2 input',
'扩展1输入X3输入':'Expansion board 1 X3 input',
'扩展1输入X4输入':'Expansion board 1 X4 input',
'扩展1输入X5输入':'Expansion board 1 X5 input',
'扩展1输入X6输入':'Expansion board 1 X6 input',
'扩展1输入X7输入':'Expansion board 1 X7 input',
'扩展1输入X8输入':'Expansion board 1 X8 input',
'扩展1输入X9输入':'Expansion board 1 X9 input',
'扩展1输入X10输入':'Expansion board 1 X10 input',
'扩展2输入X1输入':'Expansion board 2 X1 input',
'扩展2输入X2输入':'Expansion board 2 X2 input',
'扩展2输入X3输入':'Expansion board 2 X3 input',
'扩展2输入X4输入':'Expansion board 2 X4 input',
'扩展2输入X5输入':'Expansion board 2 X5 input',
'扩展2输入X6输入':'Expansion board 2 X6 input',
'扩展2输入X7输入':'Expansion board 2 X7 input',
'扩展2输入X8输入':'Expansion board 2 X8 input',
'扩展2输入X9输入':'Expansion board 2 X9 input',
'扩展2输入X10输入':'Expansion board 2 X10 input',
'扩展1输出Y1输出':'Expansion board 1 Y1 output',
'扩展1输出Y2输出':'Expansion board 1 Y2 output',
'扩展1输出Y3输出':'Expansion board 1 Y3 output',
'扩展1输出Y4输出':'Expansion board 1 Y4 output',
'扩展1输出Y5输出':'Expansion board 1 Y5 output',
'扩展1输出Y6输出':'Expansion board 1 Y6 output',
'扩展1输出Y7输出':'Expansion board 1 Y7 output',
'扩展1输出Y8输出':'Expansion board 1 Y8 output',
'扩展1输出Y9输出':'Expansion board 1 Y9 output',
'扩展1输出Y10输出':'Expansion board 1 Y10 output',
'扩展2输出Y1输出':'Expansion board 2 Y1 output',
'扩展2输出Y2输出':'Expansion board 2 Y2 output',
'扩展2输出Y3输出':'Expansion board 2 Y3 output',
'扩展2输出Y4输出':'Expansion board 2 Y4 output',
'扩展2输出Y5输出':'Expansion board 2 Y5 output',
'扩展2输出Y6输出':'Expansion board 2 Y6 output',
'扩展2输出Y7输出':'Expansion board 2 Y7 output',
'扩展2输出Y8输出':'Expansion board 2 Y8 output',
'扩展2输出Y9输出':'Expansion board 2 Y9 output',
'扩展2输出Y10输出':'Expansion board 2 Y10 output',
'上行':'Up',
'停止':'Stop',
'下行':'Down',
'关门中':'Closing door',
'开门':'Open door',
'关门':'Closed door',
'开门中':'Opening door',
'正常':'Normal',
'检修':'Repair',
'故障':'Error',
'锁梯':'Lock lift',
'消防':'Fire',
'门区外':'Without leveling',
'门区内':'Leveling',
'超载':'Over load',
'未正常':'Unnormal',
'满载':'Fullload',
'无密码':'No password',
'有密码':'Password',
'开关松开':'Switch off',
'开关按下':'Switch on',
'无效':'No',
'有效':'Yes',
'开环矢量':'Sensorless vector control',
'闭环矢量':'Feedback vector control',
'V/F方式':'Voltage/Frequency',
'操作面板控制':'Operation control',
'距离控制':'Distance control',
'无操作':'No operation',
'静止调谐':'Static auto-tuning',
'完整调谐':'Dynamic auto-tuning',
'井道自学习1':'Shaft self-learning 1',
'井道自学习2':'Shaft self-learning 2',
'同步机静态调谐':'Syn-motor static tuning',
'异步电动机#':'Asynchronous motor',
'同步电动机#':'Synchronous motor',
'方向相同':'Positive',
'运行方向取反':'Opposite',
'上平层常开':'Level contactor 1 NO',
'下平层常开':'Level contactor 2 NO',
'门区常开':'Leveling position NO',
'安全回路反馈常开':'Safety circuit feedback NO',
'门锁回路反馈常开':'Door and lock closed feedback NO',
'运行接触器反馈常开':'Motor contactor feedback NO',
'抱闸反馈常开':'Brake contactor feedback NO',
'检修信号常开':'Service signal NO',
'检修/紧急电动上行常开':'Service up driving signal NO',
'检修/紧急电动下行常开':'Service down driving signal NO',
'消防信号常开':'Fire signal NO',
'上限位常开':'Up limit signal NO',
'下限位常开':'Down limit signal NO',
'超载常开':'Overload signal NO',
'满载常开':'Full load signal NO',
'消防员运行常开':'Fire2 input signal NO',
'门1光幕常开':'Light curtain 1 NO',
'门2光幕常开':'Light curtain 2 NO',
'抱闸行程开关1反馈常开':'Brake position feedback 1 NO',
'停电应急运行常开':'UPS input signal NO',
'锁梯常开':'Lift locked signal NO',
'安全回路2反馈常开':'Safety circuit feedback 2 NO',
'门锁回路2反馈常开':'Door and lock closed feedback 2 NO',
'上平层常闭':'Level contactor 1 NC',
'下平层常闭':'Level contactor 2 NC',
'门区常闭':'Leveling position NC',
'安全回路反馈常闭':'Safety circuit feedback NC',
'门锁回路反馈常闭':'Door and lock closed feedback NC',
'运行接触器反馈常闭':'Motor contactor feedback NC',
'抱闸反馈常闭':'Brake contactor feedback NC',
'检修信号常闭':'Service signal NC',
'检修/紧急电动上行常闭':'Service up driving signal NC',
'检修/紧急电动下行常闭':'Service down driving signal NC',
'消防信号常闭':'Fire signal NC',
'上限位常闭':'Up limit signal NC',
'下限位常闭':'Down limit signal NC',
'超载常闭':'Overload signal NC',
'满载常闭':'Full load signal NC',
'消防员运行常闭':'Fire2 input signal NC',
'门1光幕常闭':'Light curtain 1 NC',
'门2光幕常闭':'Light curtain 2 NC',
'抱闸行程开关1反馈常闭':'Brake position feedback 1 NC',
'停电应急运行常闭':'UPS input signal NC',
'锁梯常闭':'Lift locked signal NC',
'安全回路2反馈常闭':'Safety circuit feedback 2 NC',
'门锁回路2反馈常闭':'Door and lock closed feedback 2 NC',
'电机过热常开':'Motor overheated signal NO',
'地震信号常开':'Earthquake signal NO',
'轻载常开':'Light load NO',
'半载常开':'Half load NO',
'消防基站切换常开':'Alternative fire escape floor enable',
'门1开门输入常开':'Open door button 1',
'门2开门输入常开':'Open door button 2',
'外部故障输入常开':'External fault input signal',
'门锁1短接常开':'Door lock 1 connect',
'门锁2短接常开':'Door lock 2 connect',
'紧急电动常开':'Emergency evacuation signal',
'电机过热常闭':'Motor overheated signal',
'地震信号常闭':'Earthquake signal',
'轻载常闭':'Light load NC',
'半载常闭':'Half load NC',
'消防基站切换常闭':'Alternative fire escape floor enable',
'门1开门输入常闭':'Open door button 1',
'门2开门输入常闭':'Open door button 2',
'外部故障输入常闭':'External fault input signal',
'门锁1短接常闭':'Door lock 1 connect',
'门锁2短接常闭':'Door lock 2 connect',
'抱闸电机脉冲输入常开':'Pulse capture 1',
'抱闸微动开关1常开':'Brake position feedback 1',
'抱闸微动开关2常开':'Brake position feedback 2',
'轿顶撑杆开关常开':'Top prop position contactor',
'浸水信号常开':'Water sensor signal',
'抱闸电机脉冲输入常闭':'Pulse capture 1',
'抱闸微动开关1常闭':'Brake position feedback 1',
'抱闸微动开关2常闭':'Brake position feedback 2',
'轿顶撑杆开关常闭':'Top prop position contactor',
'浸水信号常闭':'Water sensor signal',
'运行接触器':'Motor contactor output',
'抱闸接触器':'Brake contactor output',
'消防到基站':'Fire escape floor arrived',
'门机1开门':'Open door signal 1 output',
'门机1关门':'Close door signal 1 output',
'门机2开门':'Open door signal 2 output',
'门机2关门':'Close door signal 2 output',
'抱闸/运行接触器正常':'Contactor operates normally',
'故障状态':'Error',
'运行状态':'System running',
'救援自动切换':'ARD mode enable',
'一体化正常状态':'Controller valid, always output',
'救援蜂鸣提示':'Buzzer sounds when leveling in evacuation',
'上行信号':'Upwards running signal',
'照明风扇运行':'Lamp output signal',
'非门区停车':'Stop without leveling',
'电锁控制':'Electric lock output signal',
'非服务状态提示':'Lift cannot be used',
'救援运行完成输出':'Evacuation completed',
'抱闸电机正向输出':'Brake motor CW output',
'抱闸电机反向输出':'Brake motor CCW output',
'安全回路信号':'Safety circuit signal',
'门锁回路信号1':'Door and lock closed signal 1',
'门锁回路信号2':'Door and lock closed signal 2',
'门锁1短接':'Door lock 1 connect',
'门锁2短接':'Door lock 2 connect',
'外召有效':'Hall call allowable',
'禁止外召':'Hall call forbidden',
'允许开门':'Door open allowable',
'禁止开门':'Door open forbidden',
'禁止超载运行':'Overload running forbidden',
'允许超载运行':'Overload running allowable',
'限位开关有效':'Limit switch allowable',
'限位开关无效':'Limit switch forbidden',
'电机无运行':'ARD power none',
'UPS供电运行':'UPS',
'48V蓄电池供电运行':'48V battery',
'锁梯信号':'Lift locked',
'消防信号':'Fire singal',
'轻载常开输入#':'Light load NO INPUT',
'半载常开输入#':'Half load NO INPUT',
'消防基站切换常开输入':'Alternative fire escape floor enable',
'门1开门常开输入':'Door 1 open input',
'门2开门常开输入':'Door 2 open input',
'轻载常闭输入#':'Light load NC INPUT',
'半载常闭输入#':'Half load NC INPUT',
'消防基站切换常闭输入':'Alternative fire escape floor enable',
'门1开门常闭输入':'Door 1 open input',
'门2开门常闭输入':'Door 2 open input',
'门机 1 开门':'Open door signal 1 output',
'门机 1 关门':'Close door signal 1 output',
'门机 2 开门':'Open door signal 2 output',
'门机 2 关门':'Close door signal 2 output',
'电梯上行信号':'Upwards running signal',
'照明风扇输出':'Lamp output signal',
'非门区停车#':'Stop without leveling',
'电锁输出#':'Electric lock output signal',
'救援完成输出':'Lift cannot be used',
'停电应急状态输出':'Ard output signal',
//ebs,
'电流':'Current',
'电压':'Voltage',
'上平层':'Up leveling',
'下平层':'Down leveling',
'门区':'Door zone',
'安全回路反馈':'Safety circuit feedback',
'门锁回路反馈':'Door lock circuit feedback',
'运行接触器反馈':'RUN contactor feedback',
'抱闸反馈':'Brake feedback',
'检修信号':'Inspection signal',
'检修/紧急电动上行':'Inspection/EEO up',
'检修/紧急电动下行':'Inspection/EEO down',
'消防信号':'Fire emergency signal',
'上限位':'Up limit signal',
'下限位':'Down limit signal',
'超载':'Overload',
'满载':'Full-load',
'上1级强减':'Up slow-down switch 1',
'下1级强减':'Down slow-down switch 1',
'上2级强减':'Up slow-down switch 2',
'下2级强减':'Down slow-down switch 2',
'上3级强减':'Up slow-down switch 3',
'下3级强减':'Down slow-down switch 3',
'封门反馈':'Shorting door lock circuit relay feedback',
'消防员运行':"Firefighter's Service",
'门1光幕':'Door 1 light curtain',
'门2光幕':'Door 2 light curtain',
'抱闸行程开关1反馈':'Brake travel switch 1 feedback',
'停电应急运行':'Emergency evacuation at power failure',
'锁梯':'Elevator lock',
'安全回路2反馈':'Safety circuit 2 feedback',
'封星反馈':'Shorting motor stator contactor feedback',
'门锁回路2反馈':'Door lock circuit 2 feedback',
'门1安全触板反馈':'Door 1 safety edge feedback',
'门2安全触板反馈':'Door 2 safety edge feedback',
'电机过热':'Motor overheat',
'地震信号':'Earthquake signal',
'后门禁止':'Rear door forbidden signal',
'轻载':'Light-load',
'半载':'Half-load',
'消防基站切换':'Fire emergency floor switchover signal',
'假楼层输入':'Dummy floor input',
'门1开门输入':'Door 1 open signal',
'门2开门输入':'Door 2 open signal',
'报闸行程开关2反馈':'Brake travel switch 2 feedback',
'外部故障输入':'External fault signal',
'端站校验信号':'Terminal floor verification signal',
'门锁1短接':'Door lock 1 shorting',
'门锁2短接':'Door lock 2 shorting',
'紧急电动':'EEO',
'门锁旁路输入':'Door lock bypass input',
'夹绳器反馈':'Rope gripper feedback',
'安全回路信号':'Safety circuit signal',
'门锁回路信号1':'Door lock circuit signal 1',
'门锁回路信号2':'Door lock circuit signal 2',
'门锁1短接':'Door lock 1 shorting',
'门锁2短接':'Door lock 2 shorting',
'运行接触器':'RUN contactor',
'抱闸接触器':'Brake contactor',
'封门接触器':'Shorting door lock circuit relay',
'消防到基站':'Fire emergency floor arrival signal feedback',
'门机1开门':'Door open by door operator 1',
'门机1关门':'Door close by door operator 1',
'门机2开门':'Door open by door operator 2',
'门机2关门':'Door close by door operator 2',
'抱闸/运行接触器正常':'Brake/ RUN contactors healthy',
// '故障状态':'Fault state',
'运行状态':'Running state',
'封星接触器':'Shorting motor stator contactor',
'救援自动切换':'Emergency evacuation automatic switchover',
'一体化正常状态':'Normal state of integration',
'救援蜂鸣提示':'Emergency buzzer control',
'抱闸强激':'High-voltage startup of brake',
'上行信号':'Up signal',
'照明风扇运行':'Light/fan running',
'医用消毒控制':'Medical sterilization control',
'非门区停车':'Non-door zone stop',
'电锁控制':'Electromagnetic lock control',
'非服务状态提示':'Non-service state indication',
'救援运行完成输出':'Emergency evacuation completed',
'夹绳器复位':'Rope gripper reset',
'制动管直通输出':'Braking transistor short circuit output',
'报警过滤输出':'Alarm filter output',
'光幕1':'Light curtain 1',
'光幕2':'Light curtain 2',
'开门到位1':'Door open limit 1',
'开门到位2':'Door open limit 2',
'关门到位1':'Door close limit 1',
'关门到位2':'Door close limit 2',
'满载信号':'Full-load signal',
'超载信号':'Overload signal',
'开门按钮':'Door open button',
'关门按钮':'Door close button',
'开门延时按钮':'Door open delay button',
'直达信号':'Direct travel ride signal',
'司机信号':'Attendant signal',
'换向信号':'Direction change signal',
'独立运行信号':'Independent running signal',
'消防员操作信号':'Firefighter operation signal',
'开门输出1':'Door open output 1',
'关门输出1':'Door close output 1',
'门锁信号':'Door lock signal',
'开门输出2':'Door open output 2',
'关门输出2':'Door close output 2',
'门锁信号':'Door lock signal',
'上到站钟标记':'Up arrival gong',
'下到站钟标记':'Down arrival gong',
'开门按钮显示':'Door open button display',
'关门按钮显示':'Door close button display',
'开门延时按钮显示':'Door open delay button display',
'非门区停车输出':'Non-door zone stop output',
'蜂鸣器输出':'Buzzer output',
'节能标记':'Energy-saving sign',
'无效':'Disabled',
'有效':'Enabled',
'说明':'Description',
'光幕1':'Light curtain 1',
'光幕2':'Light curtain 2',
'开门到位1':'Door open limit 1',
'开门到位2':'Door open limit 2',
'关门到位1':'Door close limit 1',
'关门到位2':'Door close limit 2',
'满载信号':'Full-load signal',
'超载信号':'Overload signal',
'开门按钮':'Door open button',
'关门按钮':'Door close button',
'开门延时按钮':'Door open delay button',
'直达信号':'Direct travel ride signal',
'司机信号':'Attendant signal',
'换向信号':'Direction change signal',
'独立运行信号':'Independent running signal',
'消防员操作信号':'Firefighter operation signal',
'平台急停':'Emergency stop',
'安全边1':'Safety edge 1',
'安全边2':'Safety edge 2',
'安全边3':'Safety edge 3',
'超载':'Overload',
'轿内IC卡':'Car IC card',
'安装模式检修':'Installation mode inspection',
'锁梯':'Elevator lock',
'消防':'Fire emergency',
'地震':'Earthquake',
'UPS接入':'UPS input',
'紧急电动':'EEO',
'紧急电动上行':'EEO up',
'故障复位':'Fault reset',
'紧急电动下行':'EEO down',
'自动门前门开门到位':'Front door open limit',
'自动门中门开门到位':'Middle door open limit',
'自动门后门开门到位':'Rear door open limit',
'自动门前门关门到位':'Front door close limit',
'自动门后门关门到位':'Rear door close limit',
'自动门中门关门到位':'Middle door close limit',
'前门闭门触点有效':'Front door close contact active',
'中门闭门触点有效':'Middle door close contact active',
'后门闭门触点有效':'Rear door close contact active',
'前门闭锁触点有效':'Front lock close contact active',
'中门闭锁触点有效':'Middle lock close contact active',
'后门闭锁触点有效':'Rear lock close contact active',
'门锁末端':'Door lock circuit end',
'安全末端':'Safety circuit end',
'开门输出1':'Door open output 1',
'关门输出1':'Door close output 1',
'门锁信号':'Door lock signal',
'开门输出2':'Door open output 2',
'关门输出2':'Door close output 2',
'上到站钟标记':'Up arrival gong',
'下到站钟标记':'Down arrival gong',
'开门按钮显示':'Door open button display',
'关门按钮显示':'Door close button display',
'开门延时按钮显示':'Door open delay button display',
'非门区停车输出':'Non-door zone stop output',
'保留':'Reserved',
'蜂鸣器输出':'Buzzer output',
'节能标记':'Energy-saving',
'前门电锁输出':'Front door electromagnetic lock output',
'中门电锁输出':'Middle door electromagnetic lock output',
'后门电锁输出':'Rear door electromagnetic lock output',
'自动开门器前门开门':'Automatic door opener front door open',
'自动开门器中门开门':'Automatic door opener middle door open',
'自动开门器后门开门':'Automatic door opener rear door open',
'自动开门器前门关门':'Automatic door opener front door close',
'自动开门器中门关门':'Automatic door opener middle door close',
'自动开门器后门关门':'Automatic door opener rear door close',
'0：光幕未遮挡；1：光幕被遮挡':'0: Light curtain not blocked; 1: Light curtain blocked',
'0：光幕未遮挡；1：光幕被遮挡':'0: Light curtain not blocked; 1: Light curtain blocked',
'0：主门未开门到位；1：主门开门到位':'0: Main door not reaching door open limit; 1: Main door reaching door open limit',
'0：副门未开门到位；1：副门开门到位':'0: Auxiliary door not reaching door open limit; 1: Auxiliary door reaching door open limit',
'0：主门未关门到位；1：主门关门到位':'0: Main door not reaching door close limit; 1: Main door reaching door close limit',
'0：副门未关门到位；1：副门关门到位':'0: Auxiliary door not reaching close open limit; 1: Auxiliary door reaching door close limit',
'无效':'Disabled',
'0：未按下；1：按下':'0: Not pressed; 1: Pressed',
'无效':'Disabled',
'0：被按下或断线；1：正常':'0: Not pressed or disconnected; 1: Normal',
'0：被遮挡；1：正常':'0: Blocked; 1: Normal',
'0：正常；1：超载开关触发':'0: Normal; 1: Overload switch triggered',
'0：未刷卡；1：刷卡':'0:  Card not swiped; 1: Card swiped',
'0：非安装模式；1：安装模式':'0: Non-installation mode; 1: Installation mode',
'0：锁梯未开启；1：锁梯开启':'0: Elevator lock disabled; 1: Elevator lock enabled',
'0：正常；1：消防传感器触发':'0: Normal; 1: Fire emergency sensor triggered',
'0：正常；1：地震传感器触发':'0: Normal; 1: Earthquake sensor triggered',
'无效':'Disabled',
'0：非紧急电动模式；1：紧急电动模式':'0: Non-EEO mode; 1: EEO',
'0：未按下；1：按下':'0: Not pressed; 1: Pressed',
'0：未到位；1：到位':'0: Limit not implemented; 1: Limit implemented',
'0：未接通；1：接通':'0: Not connected; 1: Connected',
'0：无动作；1：主门开门中':'0: No action; 1: Main door opening',
'0：无动作；1：主门关门中':'0: No action; 1: Main door closing',
'0：无输出；1：输出中':'0: No output; 1: Outputting',
'0：无动作；1：副门开门中':'0: No action; 1: Auxiliary door opening',
'0：无动作；1：副门关门中':'0: No action; 1: Auxiliary door closing',
'0：未上行到站；1：上行到站（1S）':'0: No up arrival; 1: Up arrival (1s)',
'0：未下行到站；1：下行到站（1S）':'0: No down arrival; 1: Down arrival (1s)',
'0：无显示；1：开门中':'0: No display;  1: Opening',
'0：无显示；1：关门中':'0: No display;  1: Closing',
'无效':'Disabled',
'0：正常；1：非门区停车':'0: Normal; 1: Non-door zone stop',
'无效':'Disabled',
'0：无输出；1：输出中':'0: No output; 1: Outputting',
'0：未节能；1：节能':'0: No energy-saving; 1: Energy-saving',
'0：无输出；1：输出中':'0: No output; 1: Outputting',
'0：无动作；1：开门中':'0: No action; 1: Opening',
'0：无动作；1：关门中':'0: No action; 1: Closing',
// '标准3000+cibes':'NICE3000new_CIBES',
// '标准3000+系统_435/WLE':'NICE3000new-System_435/WLE',
'模板一':'Template 1',
'模板二':'Template 2',
'模板三':'Template 3',
'提交成功':'Submission succeeded',
'短信重复':'SMS repeated',
'短信发送频率超出业务范围，短信发送失败':'SMS sending frequency is out of scope, and SMS sending fails',
'电话号码格式错误!':'Incorrect number format!',
'发送短信失败':'Sending failed',
'维保报表':'Maintenance report',
'维保年报表':'Annual maintenance report',
'维保季报表':'Quarterly maintenance report',
'维保月报表':'Monthly maintenance report',
'管理员强制完成救援':'Forced rescue by admin',
'坐席绑定':'Operator line bound',
'坐席解绑':'Operator line unbound',
'添加坐席':'Add operator line',
'编辑坐席':'Edit operator line',
'困人任务删除附件':'Delete passenger trap attachment',
'困人任务添加附件':'Add passenger trap attachment',
'通话录音':'Call recording',
'故障处置':'Fault handling',
'手动建单':'Manually create',
'上报':'Report',
'添加投放范围':'Add publicity range',
'编辑投放范围':'Edit publicity range',
'删除投放范围':'Delete publicity range',
'审核投放范围':'Review publicity range',
'更新媒体素材':'Update media materials',
'删除媒体素材':'Delete media materials',
'审核媒体素材':'Review media materials',
'新增媒体素材':'Add media materials',
'作废媒体素材':'Discard media materials',
'恢复媒体素材':'Restore media materials',
'更新播放列表':'Update playlist',
'删除播放列表':'Delete playlist',
'审核播放列表':'Review playlist',
'添加播放列表':'Add playlist',
'克隆播放列表':'Copy playlist',
'作废播放列表':'Discard playlist',
'恢复播放列表':'Restore playlist',
'操作日志':'Operation log',
'保养合同附件':'Maintenance contract appendix',
'保养合同添加附件':'Add appendix to maintenance contract',
'保养合同查看附件':'View appendix to maintenance contract',
'保养合同删除附件':'Delete appendix to maintenance contract',
'保养合同下载附件':'Download appendix to maintenance contract',
'归档保养合同附件':'Document maintenance contract appendix',
'合同终止':'Termination of contract',
'审核媒体投放':'Review media publicity',
'添加媒体投放':'Add media publicity',
'删除媒体投放':'Delete media publicity',
'下发媒体':'Distribute media',
'作废媒体投放':'Discard media publicity',
'恢复媒体投放':'Restore media publicity',
'添加公告模板':'Add notice template',
'编辑公告模板':'Edit notice template',
'删除公告模板':'Delete notice template',
'生效':'Effective',
'审核公告投放':'Review notice publicity',
'添加公告投放':'Add notice publicity',
'删除公告投放':'Delete notice publicity',
'下发公告':'Distribute notice',
'作废公告投放':'Discard notice publicity',
'恢复投放公告':'Restore notice publicity',
'批量下发媒体列表':'Distribute media playlist in bulk',
'批量下发文字公告':'Distribute notices in bulk',
'批量下发系统配置':'Distribute system configurations in bulk',
'导出无线下发列表':'Export wireless distribution list',
'查看媒体投放记录':'View media publicity records',
'一键制卡':'Prepare card in one click',
'添加系统配置':'Add system configuration',
'编辑系统配置':'Edit system configuration',
'删除系统配置':'Delete system configuration',
'审核系统配置模板':'Review system configuration template',
'克隆系统配置':'Copy system configuration',
'反馈':'Feedback',
'批量导入维保记录':'Import maintenance records in bulk',
'录入维保记录':'Enter maintenance records',
'编辑维保历史':'Edit maintenance history',
'批量录入维保记录':'Enter maintenance records in bulk',
'批量操作接入平台':'Operate access platforms in bulk',
'添加自检项':'Add self-test items',
'添加维保合同':'Add maintenance contract',
'编辑维保合同':'Edit maintenance contract',
'终止维保合同':'Terminate maintenance contract',
'归档维保合同':'Document maintenance contract',
'复制维保合同':'Copy maintenance contract',
'编辑自检项':'Edit self-test items',
'删除自检项':'Delete self-test items',
'批量操作接入维保平台':'Operate maintenance platforms in bulk',
'添加驻点':'Add maintenance station',
'编辑':'Edit',
'删除驻点':'Delete maintenance station',
'添加保养单':'Add maintenance form',
'编辑保养单':'Edit maintenance form',
'删除保养单':'Delete maintenance form',
'发送保养单':'Send maintenance form',
'作废保养单':'Discard maintenance form',
'导入保养单':'Import maintenance form',
'查看电梯保养计划':'View maintenance schedule',
'顺达工单重传':'Shunda (lift) work order re-upload',
'添加维保站点':'Add maintenance station',
'添加维修单':'Add repair sheet',
'编辑维修单':'Edit repair sheet',
'删除维修单':'Delete repair sheet',
'发送维修单':'Send repair sheet',
'作废维修单':'Discard repair sheet',
'编辑维保站点':'Edit maintenance station',
'删除维保站点':'Delete maintenance station',
'导入维保站点':'Import maintenance station',
'添加维保班组':'Add maintenance shift',
'添加配件':'Add accessory',
'导入维保班组':'Import maintenance shift',
'编辑配件':'Edit accessory',
'编辑维保班组':'Edit maintenance shift',
'导入配件':'Import accessory',
'导出配件':'Export accessory',
'删除维保班组':'Delete maintenance shift',
'删除配件':'Delete accessory',
'添加维保人员':'Add maintenance personnel',
'编辑维保人员':'Edit maintenance personnel',
'删除维保人员':'Delete maintenance personnel',
'绑定账户':'Bind account',
'解除账户':'Cancel account',
'导出维保人员':'Export maintenance personnel',
'复职维保人员':'Restore maintenance personnel functions',
'导入维保人员':'Import maintenance personnel',
'一键生成本月保养单':'Create maintenance form this month',
'一键生成下月保养单':'Create maintenance form next month',
'确认保养单':'Confirm maintenance form',
'查看处理流程':'View the process flow',
'年检登记':'Annual inspection registration',
'年检历史':'Annual inspection history',
'创建自检工单':'Create self-test work order',
'导出':'Export',
'添加自检单':'Add self-test form',
'编辑自检单':'Edit self-test form',
'删除自检单':'Delete self-test form',
'发送自检单':'Send self-test form',
'作废自检单':'Discard self-test form',
'完成情况':'Completion',
'导出自检工单':'Export self-test work order',
'编辑自检工单':'Edit self-test work order',
'删除自检工单':'Delete self-test work order',
'作废自检工单':'Discard self-test work order',
'添加二维码':'Add QR code',
'编辑媒体客户':'Edit media clients',
'删除媒体客户':'Delete media clients',
'添加媒体客户':'Add media clients',
'一键替换/下刊媒体素材':'Replace/delete media materials with one-click',
'下发播放列表':'Distribute media playlist',
'查看下发详情':'View distribution details',
'审核系统配置':'Review system configuration',
'编辑物业单位人员':'Edit property management personnel',
'删除物业单位人员':'Delete property management personnel',
'添加物业单位人员':'Add property management personnel',
'维保预测管理':'Maintenance prediction management',
'添加语言配置项':'Add language configuration',
'导入语言配置字段':'Import language fields',
'导出语言配置字段':'Export language fields',
'添加子系统':'Add subsystem',
'删除':'Delete',
'发布子系统':'Release subsystem',
'维保预测列表':'Maintenance prediction list',
'维保预测处理':'Maintenance prediction handling',
'原始数据列表':'Raw data list',
'导出维保预测原始数据':'Export raw data of maintenance prediction',
'批量导入年检登记':'Import annual inspection registration in bulk',
'导出年检信息':'Export annual inspection information',
'批量年检登记':'Annual inspection registration in bulk',
'编辑年检记录':'Edit annual inspection records',
'电梯年检登记':'Elevator annual inspection registration',
'年检信息导出':'Annual inspection information export',
'年检导出':'Annual inspection export',
'返回':'Return',
'添加保养项':'Add maintenance item',
'编辑保养项':'Edit maintenance item',
'删除保养项':'Delete maintenance item',
'添加保养类型':'Add maintenance type',
'编辑保养类型':'Edit maintenance type',
'删除保养类型':'Delete maintenance type',
'编辑出厂信息':'Edit ex-factory information',
'提交出厂信息':'Submit ex-factory information',
'删除出厂信息':'Delete ex-factory information',
'添加出厂信息':'Add ex-factory information',
'新增配件':'Add accessory',
'修改配件':'Modify accessory',
'导入电梯':'Import elevator',
'导入':'Import',
'编辑安装信息':'Edit installation information',
'提交安装信息':'Submit installation information',
'复制电梯出厂信息':'Copy elevator ex-factory information',
'刷新电梯状态':'Refresh elevator state',
'编辑维保信息':'Edit maintenance information',
'提交维保信息':'Submit maintenance information',
'导入电梯信息':'Import elevator information',
'正常编制':'Preparation',
'导入电梯号码':'Import elevator number',
'修改电梯电话':'Modify elevator phone',
'批量删除电梯':'Delete elevators in bulk',
'添加电梯信息':'Add elevator information',
'复制电梯信息':'Copy elevator information',
'编辑电梯信息':'Edit elevator information',
'删除电梯':'Delete elevator',
'解绑维保单位':'Unbind maintenance unit',
'批量编辑维保信息':'Edit maintenance information in bulk',
'批量修改电梯信息':'Modify elevator information in bulk',
'设置代理商编号':'Set agent No.',
'添加单位':'Add unit',
'编辑单位':'Edit unit',
'删除单位':'Delete unit',
'分配权限':'Assign permissions',
'下级单位一键生成用户':'Generate users with one click of submenu',
'下级单位分配电梯':'Distribute elevator by submenu',
'安全技术交底':'Safety technology disclosure',
'安全交底记录列表':'List of safety disclosure record',
'编辑安全交底项':'Edit safety disclosure items',
'删除安全交底记录':'Delete safety disclosure record',
'添加安全交底项':'Add safety disclosure items',
'导出安全交底PDF':'Export safety disclosure in PDF',
'审核安全交底项':'Review safety disclosure items',
'技术交底记录列表':'List of technical disclosure records',
'编辑技术交底项':'Edit technical disclosure items',
'添加技术交底项':'Add technical disclosure items',
'删除技术交底项':'Delete technical disclosure items',
'导出技术交底PDF':'Export technical disclosure in PDF',
'添加楼盘信息':'Add building information',
'编辑楼盘信息':'Edit building information',
'添加电梯至楼盘':'Add elevator to building',
'删除楼盘信息':'Delete building information',
'智能硬件绑定电梯':'Bind smart hardware to elevator',
'配对':'Match',
'编辑智能硬件':'Edit smart hardware',
'智能硬件解绑电梯':'Unbind smart hardware to elevator',
'修改控制器类型':'Modify controller type',
'sim卡停开机操作，可以批量':'SIM card start/stop operation in bulk',
'查看SIM卡状态':'View SIM card state',
'配对日志':'Match log',
'绑定摄像头':'Bind camera',
'解绑摄像头':'Unbind camera',
'绑定摄像头记录':'Bind camera record',
'调拨':'Dispatch',
'参数配置':'Set parameter',
'批量参数配置':'Set parameter in bulk',
'参数下发日志':'Parameter distribution log',
'添加制造厂商':'Add manufacturer',
'编辑制造厂商':'Edit manufacturer',
'删除制造厂商':'Delete manufacturer',
'添加故障级别':'Add fault level',
'编辑故障级别':'Edit fault level',
'设置故障级别处理策略':'Set troubleshooting strategy',
'删除故障级别':'Delete fault level',
'添加故障代码':'Add fault code',
'编辑故障代码':'Edit fault code',
'批量配置故障代码对应故障级别':'Pair fault codes with fault levels in bulk',
'删除故障代码':'Delete fault code',
'导入控制器密码信息':'Import controller password information',
'导出控制器密码信息':'Export controller password information',
'导入控制器辅助软件':'Import controller auxiliary software',
'导出控制器辅助软件':'Export controller auxiliary software',
'下载控制器辅助软件':'Download controller auxiliary software',
'查询控制器密码信息':'Query controller password information',
'非困人急修接受':'Accept non-passenger trap rescue',
'非困人状态修改':'Modify non-passenger trap state',
'二维码入库':'QR code for storage',
'关联机柜':'Linked cabinet',
'关联二维码':'Linked QR code',
'终端绑定/绑定':'Terminal binding',
'获取二维码信息':'Get QR code information',
'一体机加密权限认证':'Integrated controller encryption authentication',
'添加第三方身份信息':'Add third-party identity information',
'编辑第三方接入信息':'Edit third-party access information',
'删除第三方接入信息':'Delete third-party access information',
'查查第三方接入身份信息':'View third-party access identity information',
'作废保养工单':'Discard maintenance work order',
'转派保养工单':'Redeploy maintenance work order',
'延期保养工单':'Delayed maintenance work order',
'申请变更':'Change request',
'智能硬件保养':'Smart hardware maintenance',
'转派维修工单':'Redeploy repair work order',
'作废维修工单':'Discard repair work order',
'转派自检工单':'Redeploy self-test work order',
'添加角色':'Add role',
'编辑角色':'Edit role',
'设置角色对应菜单':'Set menu for role',
'复制角色':'Copy role',
'删除角色':'Delete role',
'设置角色对应用户':'Set user for role',
'编辑通用角色':'Edit general role',
'添加用户':'Add user',
'编辑用户':'Edit user',
'设置用户对应角色':'Set role for user',
'将用户强制下线':'Force user offline',
'流量管理':'Traffic management',
'停用应用':'Stop application',
'删除用户':'Delete user',
'启用应用':'Start application',
'切换新版':'Switch to new version',
'导出用户信息':'Export user information',
'远程呼梯':'Remote elevator call',
'制动力监测':'Braking force detection',
'批量编辑接警号码':'Edit alarm numbers in bulk',
'批量编辑救援单位':'Edit rescue units in bulk',
'验收设置':'Acceptance setting',
'还原':'Restore',
'设置':'Set',
'添加故障联系人':'Add fault contacts',
'编辑故障联系人':'Edit fault contacts',
'删除故障联系人':'Delete fault contacts',
'设置默认短息预览':'Set default SMS preview',
'新增菜单':'Add menu',
'上传APK文件2':'Upload APK file 2',
'删除APP':'Delete APP',
'编辑APP列表':'Edit APP list',
'增加新版本':'Add new version',
'新增':'Add',
'更新日志发布':'Update log release',
'发布':'Release',
'添加反馈类型':'Add feedback type',
'编辑反馈类型':'Editing feedback type',
'导出用户反馈':'Export user feedback',
'回复':'Reply',
'导入待解锁的设备清单':'Import device list to be unlocked',
'下发解除指令':'Issue removal command',
'读取A1-12':'Read A1-12',
'添加配置信息':'Add configuration information',
'编辑配置信息':'Edit configuration information',
'删除配置信息':'Delete configuration information',
'数据库管理':'Database administration',
'添加客户关系':'Add client relationship',
'编辑客户对应关系':'Edit client correspondence',
'删除客户对应关系':'Delete client correspondence',
'调整单位层级':'Adjust unit level',
'删除坐席':'Delete operator line',
'上1级强迫减速开关位置':'Position of up slow-down switch 1',
'下1级强迫减速开关位置':'Position of down slow-down switch 1',
'上2级强迫减速开关位置':'Position of up slow-down switch 2',
'下2级强迫减速开关位置':'Position of down slow-down switch 2',
'上3级强迫减速开关位置':'Position of up slow-down switch 3',
'下3级强迫减速开关位置':'Position of down slow-down switch 3',
'称重输入选择':'Load cell input selection',
'并联楼层偏置':'Floor offset in parallel control',
'功能参数选择':'Function parameter selection',
'报闸力检测结果':'Braking force detection result',
'抱闸力定时周期倒计时':'Countdown for braking force timing',
'防捣乱功能':'Anti-nuisance function',
'外招地址操作':'Hall call address operation',
'通讯初始化':'Communication initialization',
'恢复功能开关1':'Reset function switch 1',
'零伺服倒溜距离':'Position lock rollback distance',
'性能显示保留':'Performance display reserved',
'性能显示保留':'Performance display reserved',
'性能显示保留':'Performance display reserved',
'性能显示保留':'Performance display reserved',
'扩展板外招通讯状态1':'Communication state 1 between expansion board and HCB',
'扩展板外招通讯状态2':'Communication state 2 between expansion board and HCB',
'扩展板外招通讯状态3':'Communication state 3 between expansion board and HCB',
'手拉门门锁等待时间':'Manual door lock waiting time',
'UCMP测试模块程序版本':'UCMP test program version',
'芯片标签':'Chip label',
'上1级强减常开':'Up slow-down switch 1 NO',
'下1级强减常开':'Down slow-down switch 1 NO',
'上2级强减常开':'Up slow-down switch 2 NO',
'下2级强减常开':'Down slow-down switch 2 NO',
'上3级强减常开':'Up slow-down switch 3 NO',
'下3级强减常开':'Down slow-down switch 3 NO',
'封门反馈常开':'Shorting door lock circuit relay feedback NO',
'上1级强减常闭':'Up slow-down switch 1 NC',
'下1级强减常闭':'Down slow-down switch 1 NC',
'上2级强减常闭':'Up slow-down switch 2 NC',
'下2级强减常闭':'Down slow-down switch 2 NC',
'上3级强减常闭':'Up slow-down switch 3 NC',
'下3级强减常闭':'Down slow-down switch 3 NC',
'封门反馈常闭':'Shorting door lock circuit relay feedback NC',
'门锁旁路输入常开':'Door lock bypass input NO',
'夹绳器反馈常开':'Rope gripper feedback NO',
'安全回路对地短路检测常开':'Safety circuit short circuit to ground detection NO',
'门1安全触板反馈常闭':'Door 1 safety edge feedback NC',
'门2安全触板反馈常闭':'Door 2 safety edge feedback NC',
'紧急电动常闭':'Emergency electrical operation (EEO) NC',
'门锁旁路输入常闭':'Door lock bypass input NC',
'夹绳器反馈常闭':'Rope gripper feedback NC',
'安全回路对地短路检测常闭':'Safety circuit short circuit to ground detection NC',
'制动管短路输出':'Braking transistor short circuit output',
'主控板开关量输入':'MCB digital input',
'轿顶板开关量输入':'CTB digital input',
'轿顶板模拟量输入':'CTB analog input',
'主控板模拟量输入':'MCB analog input',
'无意义':'Meaningless',
'报闸力检测合格':'Braking force detection passed',
'报闸力检测不合格':'Braking force detection failed',
'预转矩有效':'Pre-torque valid',
'使用自动补偿功能':'Automatic compensation function enabled',
'零伺服和有称重同时生效':'Position lock and load cell both valid',
'此功能禁止':'This function disabled',
'称重判断':'Load cell judgment',
'光幕判断':'Light curtain judgment',
'轻载判断':'Light load judgment',
'反向显示，物理楼层':'Reverse direction display of physical floor',
'正向显示，物理楼层':'Forward direction display of physical floor',
'反向显示，外召数据':'Reverse direction display of hall call data',
'正向显示，外召数据':'Forward direction display of hall call data',
'正常关门':'Normal door close',
'基站开门待梯':'Waiting with door open at main floor',
'每层均开门候梯':'Waiting with door for open at each floor',
'本层禁止':'Current floor forbidden',
'贵宾信号':'VIP signal',
'保安信号':'Security signal',
'关门按钮输入（按钮)':'Door close button input',
'上行到站灯':'Up arrival indicator',
'下行到站灯':'Down arrival indicator',
'故障信号':'Fault signal',
'非服务状态输出':'Non-service state output',
'关门按钮输出（按钮)':'Door close button output',
'门机1光幕常开输入':'Door operator 1 light curtain input NO',
'门机2光幕常开输入':'Door operator 2 light curtain input NO',
'抱闸行程开关1反馈常开输入':'Brake travel switch 1 feedback input NO',
'UPS有效常开输入':'UPS active input NO',
'锁梯常开输入':'Elevator lock input NO',
'安全常开输入2':'Safety circuit input 2 NO',
'同步机自锁反馈常开输入':'Synchronous motor self-lock feedback input NO',
'门锁回路2反馈常开输入':'Door lock circuit 2 feedback input NO',
'门机1触板常开输入':'Door operator 1 safety edge input NO',
'门机2触板常开输入':'Door operator 2 safety edge input NO',
'电机过热常开输入#':'Motor overheat signal input NO#',
'地震信号常开输入':'Earthquake signal input NO#',
'后门禁止常开输入#':'Rear door forbidden input NO#',
'报闸行程开关2反馈常开输入':'Brake travel switch 2 feedback input NO',
'外部故障常开输入':'NO input of external fault',
'端站信号常开输入':'Terminal floor signal input NO',
'门2选择(门1、门2选择)常开输入':'Door 2 selection input NO',
'单双门选择常开输入':'Single/double door selection input NO',
'门机1光幕常闭输入':'Door operator 1 light curtain input NC',
'门机2光幕常闭输入':'Door operator 2 light curtain input NC',
'抱闸行程开关1反馈常闭输入':'Brake travel switch 1 feedback input NC',
'UPS有效常闭输入':'UPS active input NC',
'锁梯常闭输入':'Elevator lock input NC',
'安全常闭输入2':'Safety circuit signal 2 NC',
'同步机自锁反馈常闭输入':'Synchronous motor self-lock feedback input NC',
'门锁回路2反馈常闭输入':'Door lock circuit 2 feedback input NC',
'门机1触板常闭输入':'Door operator 1 safety edge input NC',
'门机2触板常闭输入':'Door operator 2 safety edge input NC',
'电机过热常闭输入#':'Motor overheat signal input NC#',
'地震信号常闭输入':'Earthquake signal input NC',
'后门禁止常闭输入#':'Rear door forbidden input NC#',
'报闸行程开关2反馈常闭输入':'Brake travel switch 2 feedback input NC',
'外部故障常闭输入':'NC input of external fault',
'端站信号常闭输入':'Terminal floor signal input NC',
'门2选择(门1、门2选择)常闭输入':'Door 2 selection input NC',
'单双门选择常闭输入':'Single/double door selection input NC',
'未使用':'Not used',
'同步机自锁输出':'Synchronous motor self-lock output',
'一体化控制器正常':'Controller healthy',
'应急蜂鸣输出':'Buzzer tweeting output',
'门锁有效':'Door lock active',
'夜间输出信号':'Night output signal',
'全集选':'Full collective selective',
'上集选':'Up collective selective',
'供电状态':'Power supply state',
'电梯平层信号':'Leveling signal',
'负载百分比':'Load percentage',
'负载状态':'Load state',
'厂家合同号':'Manufacturer contract No.',
'服务模式':'Service mode',
'显示楼层位数':'Floor bits display',
'显示楼层_1':'Floor display_1',
'显示楼层_2':'Floor display_2',
'面板控制运行速度':'Running speed under operating panel control',
'电梯最大运行速度':'Maximum running speed',
'电梯额定速度':'Rated elevator speed',
'电梯额定载重':'Rated load',
'初始角度（同步机）':'Encoder initial angle (synchronous motor)',
'转子电阻（异步机）':'Rotor resistance (asynchronous motor)',
'当前角度（同步机）':'Encoder current angle (synchronous motor)',
'漏感抗（异步机）':'Leakage inductance (asynchronous motor)',
'接线方式（同步机）':'Wiring mode (synchronous motor)',
'角度调整':'Angle adjustment',
'调谐选择':'Auto-tuning mode',
'编码器每转脉冲数':'Encoder PPR',
'编码器故障检测时间':'Encoder fault detection time',
'电流环比例增益':'Current loop proportional gain',
'电流环积分增益':'Current loop integral gain',
'低速运行速度':'Low running speed',
'轿内输入类型选择':'Car input signal type',
'并联选择':'Parallel connection selection',
'测试楼层1':'Test floor 1',
'测试楼层2':'Test floor 2',
'测试楼层3':'Test floor 3',
'测试次数':'Test times',
'超载功能选择':'Overload function',
'轿内负荷空载设置':'No-load measured by load cell',
'轿内负荷满载设置':'Full-load measured by load cell',
'风扇(照明)关闭时间':'Fan/Lighting off time',
'设定运行时间(保留)':'Running time setting (reserved)',
'设定运行(保留)':'Running setting (reserved)',
'软件版本(FK)':'Software version(FK)',
'运行基站门状态':'Main floor door state',
'上电对地短路检测选择':'Detection of short circuit to ground at power-on',
'过载保护选择':'Overload protection selection',
'第1次故障信息':'1st fault information',
'第1次故障信息月日':'1st fault month and day',
'第2次故障信息':'2nd fault information',
'第2次故障信息月日':'2nd fault month and day',
'第3次故障信息':'3rd fault information',
'第3次故障信息月日':'3rd fault month and day',
'第4次故障信息':'4th fault information',
'第4次故障信息月日':'4th fault month and day',
'第5次故障信息月日':'5th fault month and day',
'第6次故障信息月日':'6th fault month and day',
'第7次故障信息月日':'7th fault month and day',
'第8次故障信息月日':'8th fault month and day',
'第9次故障信息月日':'9th fault month and day',
'第10次故障信息':'10th fault information',
'第10次故障信息月日':'10th fault month and day',
'最近一次故障信息':'Latest fault information',
'最近一次故障时速度':'Speed upon latest fault',
'最近一次故障时电流':'Current upon latest fault',
'最近一次故障时母线电压':'Bus voltage upon latest fault',
'最近一次故障月日':'Latest fault month and day',
'最近一次故障时间':'Latest fault time',
'数据格式':'Data format',
'电梯厂功能设定选择':'Elevator manufacturer function setting',
'变频器型号':'AC drive model',
'温度曲线':'Temperature curve',
'软件欠压点':'Software undervoltage threshold',
'软件过流点':'Software overcurrent threshold',
'电压校正系数':'Voltage correction coefficient',
'电流校正系数':'Current correction coefficient',
'参数更新':'Parameter update',
'用户设定检查':'User parameter check',
'停机状态':'Stop state',
'一体机V版本':'Integrated controller V version',
'一体机F版本':'Integrated controller F version',
'一体机L版本':'Integrated controller L version',
'一体机型号':'Controller model',
'平层调整模式':'Leveling adjustment mode',
'平层调整记录1':'Leveling adjustment record 1',
'平层调整记录2':'Leveling adjustment record 2',
'平层调整记录3':'Leveling adjustment record 3',
'平层调整记录4':'Leveling adjustment record 4',
'平层调整记录5':'Leveling adjustment record 5',
'平层调整记录6':'Leveling adjustment record 6',
'平层调整记录7':'Leveling adjustment record 7',
'平层调整记录8':'Leveling adjustment record 8',
'平层调整记录9':'Leveling adjustment record 9',
'平层调整记录10':'Leveling adjustment record 10',
'平层调整记录11':'Leveling adjustment record 11',
'平层调整记录12':'Leveling adjustment record 12',
'平层调整记录13':'Leveling adjustment record 13',
'平层调整记录14':'Leveling adjustment record 14',
'平层调整记录15':'Leveling adjustment record 15',
'平层调整记录16':'Leveling adjustment record 16',
'平层调整记录17':'Leveling adjustment record 17',
'平层调整记录18':'Leveling adjustment record 18',
'平层调整记录19':'Leveling adjustment record 19',
'平层调整记录20':'Leveling adjustment record 20',
'一级密码':'Level 1 password',
'二级密码':'Level 2 password',
'三级密码':'Level 3 password',
'第1次故障子码':'1st fault subcode',
'第1次逻辑信息':'Logic information upon 1st fault',
'第1次曲线信息':'Curve information upon 1st fault',
'第1次设定速度':'Speed reference upon 1st fault',
'第1次反馈速度':'Feedback speed upon 1st fault',
'第1次母线电压':'Bus voltage upon 1st fault',
'第1次当前位置':'Current position upon 1st fault',
'第1次输出电流':'Output current upon 1st fault',
'第1次输出频率':'Output frequency upon 1st fault',
'第1次转矩电流':'Torque current upon 1st fault',
'第1次输出电压':'Output voltage upon 1st fault',
'第1次输出转矩':'Output torque upon 1st fault',
'第1次输出功率':'Output power upon 1st fault',
'第1次通讯干扰':'Communication interference upon 1st fault',
'第1次编码器干扰':'Encoder interference upon 1st fault',
'第1次输入状态1':'Input state 1 upon 1st fault',
'第1次输入状态2':'Input state 2 upon 1st fault',
'第1次输入状态3':'Input state 3 upon 1st fault',
'第1次输入状态4':'Input state 4 upon 1st fault',
'第1次输入状态5':'Input state 5 upon 1st fault',
'第1次输出状态1':'Output state 1 upon 1st fault',
'第1次输出状态2':'Output state 2 upon 1st fault',
'第1次轿顶输入状态':'Car top input state upon 1st fault',
'第1次轿顶输出状态':'Car top output state upon 1st fault',
'第1次厅外状态':'Hall call state upon 1st fault',
'第1次系统状态1':'System state 1 upon 1st fault',
'第1次系统状态2':'System state 2 upon 1st fault',
'第2次故障子码':'2nd fault subcode',
'第2次逻辑信息':'Logic information upon 2nd fault',
'第2次曲线信息':'Curve information upon 2nd fault',
'第2次设定速度':'Speed reference upon 2nd fault',
'第2次反馈速度':'Feedback speed upon 2nd fault',
'第2次母线电压':'Bus voltage upon 2nd fault',
'第2次当前位置':'Current position upon 2nd fault',
'第2次输出电流':'Output current upon 2nd fault',
'第2次输出频率':'Output frequency upon 2nd fault',
'第2次转矩电流':'Torque current upon 2nd fault',
'第2次输出电压':'Output voltage upon 2nd fault',
'第2次输出转矩':'Output torque upon 2nd fault',
'第2次输出功率':'Output power upon 2nd fault',
'第2次通讯干扰':'Communication interference upon 2nd fault',
'第2次编码器干扰':'Encoder interference upon 2nd fault',
'第2次输入状态1':'Input state 1 upon 2nd fault',
'第2次输入状态2':'Input state 2 upon 2nd fault',
'第2次输入状态3':'Input state 3 upon 2nd fault',
'第2次输入状态4':'Input state 4 upon 2nd fault',
'第2次输入状态5':'Input state 5 upon 2nd fault',
'第2次输出状态1':'Output state 1 upon 2nd fault',
'第2次输出状态2':'Output state 2 upon 2nd fault',
'第2次轿顶输入状态':'Car top input state upon 2nd fault',
'第2次轿顶输出状态':'Car top output state upon 2nd fault',
'第2次厅外状态':'Hall call state upon 2nd fault',
'第2次系统状态1':'System state 1 upon 2nd fault',
'第2次系统状态2':'System state 2 upon 2nd fault',
'第3次故障子码':'3rd fault subcode',
'第3次逻辑信息':'Logic information upon 3rd fault ',
'第3次曲线信息':'Curve information upon 3rd fault',
'第3次设定速度':'Speed reference upon 3rd fault',
'第3次反馈速度':'Feedback speed upon 3rd fault',
'第3次母线电压':'Bus voltage upon 3rd fault',
'第3次当前位置':'Current position upon 3rd fault',
'第3次输出电流':'Output current upon 3rd fault',
'第3次输出频率':'Output frequency upon 3rd fault',
'第3次转矩电流':'Torque current upon 3rd fault',
'第3次输出电压':'Output voltage upon 3rd fault',
'第3次输出转矩':'Output torque upon 3rd fault',
'第3次输出功率':'Output power upon 3rd fault',
'第3次通讯干扰':'Communication interference upon 3rd fault',
'第3次编码器干扰':'Encoder interference upon 3rd fault',
'第3次输入状态1':'Input state 1 upon 3rd fault',
'第3次输入状态2':'Input state 2 upon 3rd fault',
'第3次输入状态3':'Input state 3 upon 3rd fault',
'第3次输入状态4':'Input state 4 upon 3rd fault',
'第3次输入状态5':'Input state 5 upon 3rd fault',
'第3次输出状态1':'Output state 1 upon 3rd fault',
'第3次输出状态2':'Output state 2 upon 3rd fault',
'第3次轿顶输入状态':'Car top input state upon 3rd fault',
'第3次轿顶输出状态':'Car top output state upon 3rd fault',
'第3次厅外状态':'Hall call state upon 3rd fault',
'第3次系统状态1':'System state 1 upon 3rd fault',
'第3次系统状态2':'System state 2 upon 3rd fault',
'第4次故障子码':'4th fault subcode',
'第4次逻辑信息':'Logic information upon 4th fault',
'第4次曲线信息':'Curve information upon 4th fault',
'第4次设定速度':'Speed reference upon 4th fault',
'第4次反馈速度':'Feedback speed upon 4th fault',
'第4次母线电压':'Bus voltage upon 4th fault',
'第4次当前位置':'Current position upon 4th fault',
'第4次输出电流':'Output current upon 4th fault',
'第4次输出频率':'Output frequency upon 4th fault',
'第4次转矩电流':'Torque current upon 4th fault',
'第4次输出电压':'Output voltage upon 4th fault',
'第4次输出转矩':'Output torque upon 4th fault',
'第4次输出功率':'Output power upon 4th fault',
'第4次通讯干扰':'Communication interference upon 4th fault',
'第4次编码器干扰':'Encoder interference upon 4th fault',
'第4次输入状态1':'Input state 1 upon 4th fault',
'第4次输入状态2':'Input state 2 upon 4th fault',
'第4次输入状态3':'Input state 3 upon 4th fault',
'第4次输入状态4':'Input state 4 upon 4th fault',
'第4次输入状态5':'Input state 5 upon 4th fault',
'第4次输出状态1':'Output state 1 upon 4th fault',
'第4次输出状态2':'Output state 2 upon 4th fault',
'第4次轿顶输入状态':'Car top input state upon 4th fault',
'第4次轿顶输出状态':'Car top output state upon 4th fault',
'第4次厅外状态':'Hall call state upon 4th fault',
'第4次系统状态1':'System state 1 upon 4th fault',
'第4次系统状态2':'System state 2 upon 4th fault',
'第5次故障子码':'5th fault subcode',
'第5次逻辑信息':'Logic information upon 5th fault',
'第5次曲线信息':'Curve information upon 5th fault',
'第5次设定速度':'Speed reference upon 5th fault',
'第5次反馈速度':'Feedback speed upon 5th fault',
'第5次母线电压':'Bus voltage upon 5th fault',
'第5次当前位置':'Current position upon 5th fault',
'第5次输出电流':'Output current upon 5th fault',
'第5次输出频率':'Output frequency upon 5th fault',
'第5次转矩电流':'Torque current upon 5th fault',
'第5次输出电压':'Output voltage upon 5th fault',
'第5次输出转矩':'Output torque upon 5th fault',
'第5次输出功率':'Output power upon 5th fault',
'第5次通讯干扰':'Communication interference upon 5th fault',
'第5次编码器干扰':'Encoder interference upon 5th fault',
'第5次输入状态1':'Input state 1 upon 5th fault',
'第5次输入状态2':'Input state 2 upon 5th fault',
'第5次输入状态3':'Input state 3 upon 5th fault',
'第5次输入状态4':'Input state 4 upon 5th fault',
'第5次输入状态5':'Input state 5 upon 5th fault',
'第5次输出状态1':'Output state 1 upon 5th fault',
'第5次输出状态2':'Output state 2 upon 5th fault',
'第5次轿顶输入状态':'Car top input state upon 5th fault',
'第5次轿顶输出状态':'Car top output state upon 5th fault',
'第5次厅外状态':'Hall call state upon 5th fault',
'第5次系统状态1':'System state 1 upon 5th fault',
'第5次系统状态2':'System state 2 upon 5th fault',
'第6次故障子码':'6th fault subcode',
'第6次逻辑信息':'Logic information upon 6th fault',
'第6次曲线信息':'Curve information upon 6th fault',
'第6次设定速度':'Speed reference upon 6th fault',
'第6次反馈速度':'Feedback speed upon 6th fault',
'第6次母线电压':'Bus voltage upon 6th fault',
'第6次当前位置':'Current position upon 6th fault',
'第6次输出电流':'Output current upon 6th fault',
'第6次输出频率':'Output frequency upon 6th fault',
'第6次转矩电流':'Torque current upon 6th fault',
'第6次输出电压':'Output voltage upon 6th fault',
'第6次输出转矩':'Output torque upon 6th fault',
'第6次输出功率':'Output power upon 6th fault',
'第6次通讯干扰':'Communication interference upon 6th fault',
'第6次编码器干扰':'Encoder interference upon 6th fault',
'第6次输入状态1':'Input state 1 upon 6th fault',
'第6次输入状态2':'Input state 2 upon 6th fault',
'第6次输入状态3':'Input state 3 upon 6th fault',
'第6次输入状态4':'Input state 4 upon 6th fault',
'第6次输入状态5':'Input state 5 upon 6th fault',
'第6次输出状态1':'Output state 1 upon 6th fault',
'第6次输出状态2':'Output state 2 upon 6th fault',
'第6次轿顶输入状态':'Car top input state upon 6th fault',
'第6次轿顶输出状态':'Car top output state upon 6th fault',
'第6次厅外状态':'Hall call state upon 6th fault',
'第6次系统状态1':'System state 1 upon 6th fault',
'第6次系统状态2':'System state 2 upon 6th fault',
'第7次故障子码':'7th fault subcode',
'第7次逻辑信息':'Logic information upon 7th fault',
'第7次曲线信息':'Curve information upon 7th fault',
'第7次设定速度':'Speed reference upon 7th fault',
'第7次反馈速度':'Feedback speed upon 7th fault',
'第7次母线电压':'Bus voltage upon 7th fault',
'第7次当前位置':'Current position upon 7th fault',
'第7次输出电流':'Output current upon 7th fault',
'第7次输出频率':'Output frequency upon 7th fault',
'第7次转矩电流':'Torque current upon 7th fault',
'第7次输出电压':'Output voltage upon 7th fault',
'第7次输出转矩':'Output torque upon 7th fault',
'第7次输出功率':'Output power upon 7th fault',
'第7次通讯干扰':'Communication interference upon 7th fault',
'第7次编码器干扰':'Encoder interference upon 7th fault',
'第7次输入状态1':'Input state 1 upon 7th fault',
'第7次输入状态2':'Input state 2 upon 7th fault',
'第7次输入状态3':'Input state 3 upon 7th fault',
'第7次输入状态4':'Input state 4 upon 7th fault',
'第7次输入状态5':'Input state 5 upon 7th fault',
'第7次输出状态1':'Output state 1 upon 7th fault',
'第7次输出状态2':'Output state 2 upon 7th fault',
'第7次轿顶输入状态':'Car top input state upon 7th fault',
'第7次轿顶输出状态':'Car top output state upon 7th fault',
'第7次厅外状态':'Hall call state upon 7th fault',
'第7次系统状态1':'System state 1 upon 7th fault',
'第7次系统状态2':'System state 2 upon 7th fault',
'第8次故障子码':'8th fault subcode',
'第8次逻辑信息':'Logic information upon 8th fault',
'第8次曲线信息':'Curve information upon 8th fault',
'第8次设定速度':'Speed reference upon 8th fault',
'第8次反馈速度':'Feedback speed upon 8th fault',
'第8次母线电压':'Bus voltage upon 8th fault',
'第8次当前位置':'Current position upon 8th fault',
'第8次输出电流':'Output current upon 8th fault',
'第8次输出频率':'Output frequency upon 8th fault',
'第8次转矩电流':'Torque current upon 8th fault',
'第8次输出电压':'Output voltage upon 8th fault',
'第8次输出转矩':'Output torque upon 8th fault',
'第8次输出功率':'Output power upon 8th fault',
'第8次通讯干扰':'Communication interference upon 8th fault',
'第8次编码器干扰':'Encoder interference upon 8th fault',
'第8次输入状态1':'Input state 1 upon 8th fault',
'第8次输入状态2':'Input state 2 upon 8th fault',
'第8次输入状态3':'Input state 3 upon 8th fault',
'第8次输入状态4':'Input state 4 upon 8th fault',
'第8次输入状态5':'Input state 5 upon 8th fault',
'第8次输出状态1':'Output state 1 upon 8th fault',
'第8次输出状态2':'Output state 2 upon 8th fault',
'第8次轿顶输入状态':'Car top input state upon 8th fault',
'第8次轿顶输出状态':'Car top output state upon 8th fault',
'第8次厅外状态':'Hall call state upon 8th fault',
'第8次系统状态1':'System state 1 upon 8th fault',
'第8次系统状态2':'System state 2 upon 8th fault',
'第9次故障子码':'9th fault subcode',
'第9次逻辑信息':'Logic information upon 9th fault',
'第9次曲线信息':'Curve information upon 9th fault',
'第9次设定速度':'Speed reference upon 9th fault',
'第9次反馈速度':'Feedback speed upon 9th fault',
'第9次母线电压':'Bus voltage upon 9th fault',
'第9次当前位置':'Current position upon 9th fault',
'第9次输出电流':'Output current upon 9th fault',
'第9次输出频率':'Output frequency upon 9th fault',
'第9次转矩电流':'Torque current upon 9th fault',
'第9次输出电压':'Output voltage upon 9th fault',
'第9次输出转矩':'Output torque upon 9th fault',
'第9次输出功率':'Output power upon 9th fault',
'第9次通讯干扰':'Communication interference upon 9th fault',
'第9次编码器干扰':'Encoder interference upon 9th fault',
'第9次输入状态1':'Input state 1 upon 9th fault',
'第9次输入状态2':'Input state 2 upon 9th fault',
'第9次输入状态3':'Input state 3 upon 9th fault',
'第9次输入状态4':'Input state 4 upon 9th fault',
'第9次输入状态5':'Input state 5 upon 9th fault',
'第9次输出状态1':'Output state 1 upon 9th fault',
'第9次输出状态2':'Output state 2 upon 9th fault',
'第9次轿顶输入状态':'Car top input state upon 9th fault',
'第9次轿顶输出状态':'Car top output state upon 9th fault',
'第9次厅外状态':'Hall call state upon 9th fault',
'第9次系统状态1':'System state 1 upon 9th fault',
'第9次系统状态2':'System state 2 upon 9th fault',
'第10次故障子码':'10th fault subcode',
'第10次逻辑信息':'Logic information upon 10th fault',
'第10次曲线信息':'Curve information upon 10th fault',
'第10次设定速度':'Speed reference upon 10th fault',
'第10次反馈速度':'Feedback speed upon 10th fault',
'第10次母线电压':'Bus voltage upon 10th fault',
'第10次当前位置':'Current position upon 10th fault',
'第10次输出电流':'Output current upon 10th fault',
'第10次输出频率':'Output frequency upon 10th fault',
'第10次转矩电流':'Torque current upon 10th fault',
'第10次输出电压':'Output voltage upon 10th fault',
'第10次输出转矩':'Output torque upon 10th fault',
'第10次输出功率':'Output power upon 10th fault',
'第10次通讯干扰':'Communication interference upon 10th fault',
'第10次编码器干扰':'Encoder interference upon 10th fault',
'第10次输入状态1':'Input state 1 upon 10th fault',
'第10次输入状态2':'Input state 2 upon 10th fault',
'第10次输入状态3':'Input state 3 upon 10th fault',
'第10次输入状态4':'Input state 4 upon 10th fault',
'第10次输入状态5':'Input state 5 upon 10th fault',
'第10次输出状态1':'Output state 1 upon 10th fault',
'第10次输出状态2':'Output state 2 upon 10th fault',
'第10次轿顶输入状态':'Car top input state upon 10th fault',
'第101次轿顶输出状态':'Car top output state upon 10th fault',
'第10次厅外状态':'Hall call state upon 10th fault',
'第10次系统状态1':'System state 1 upon 10th fault',
'第10次系统状态2':'System state 2 upon 10th fault',
'上行':'Up',
'停止':'Stop',
'下行':'Down',
'关门中':'Door closing',
'开门':'Door open',
'关门':'Door close',
'开门中':'Door opening',
'正常':'Normal',
'检修':'Inspection',
'故障':'Fault',
'无人':'Vacant ',
'有人':'Occupied  ',
'门区外':'Outside door zone',
'门区内':'Inside door zone',
'未正常':'Abnormal',
'无密码':'Without password',
'有密码':'With password',
'开关松开':'Switch released',
'开关按下':'Switch pressed',
'开环矢量':'SVC',
'闭环矢量':'FVC',
'V/F方式':'V/f control',
'操作面板控制':'Operating panel control',
'距离控制':'Distance control',
'无操作':'No operation',
'静止调谐':'Static auto-tuning',
'完整调谐':'Complete auto-tuning',
'井道自学习1':'Shaft auto-tuning 1',
'井道自学习2':'Shaft auto-tuning 2',
'同步机静态调谐':'Synchronous motor static auto-tuning',
'异步电动机#':'Asynchronous motor#',
'同步电动机#':'Synchronous motor#',
'方向相同':'Direction unchanged',
'运行方向取反':'Direction reversed',
'上平层常开':'Up leveling signal NO',
'下平层常开':'Down leveling signal NO',
'门区常开':'Door zone signal NO',
'安全回路反馈常开':'Safety circuit feedback NO',
'门锁回路反馈常开':'Door lock circuit feedback NO',
'运行接触器反馈常开':'RUN contactor feedback NO',
'抱闸反馈常开':'Brake feedback NO',
'检修信号常开':'Inspection signal NO',
'检修/紧急电动上行常开':'Inspection/EEO up NO',
'检修/紧急电动下行常开':'Inspection/EEO down NO',
'消防信号常开':'Fire emergency signal NO',
'上限位常开':'Up limit signal NO',
'下限位常开':'Down limit signal NO',
'超载常开':'Overload signal',
'满载常开':'Full-load signal',
'消防员运行常开':'Firefighter operation NO',
'门1光幕常开':'Door 1 light curtain NO',
'门2光幕常开':'Door 2 light curtain NO',
'抱闸行程开关1反馈常开':'Brake travel switch 1 feedback NO',
'停电应急运行常开':'Emergency evacuation signal NO',
'锁梯常开':'Elevator lock NO',
'安全回路2反馈常开':'Safety circuit 2 feedback NO',
'封星反馈常开':'Shorting motor stator contactor feedback NO',
'门锁回路2反馈常开':'Door lock circuit 2 feedback NO',
'上平层常闭':'Up leveling signal NC',
'下平层常闭':'Down leveling signal NC',
'门区常闭':'Door zone signal NC',
'安全回路反馈常闭':'Safety circuit feedback NC',
'门锁回路反馈常闭':'Door lock circuit feedback NC',
'运行接触器反馈常闭':'RUN contactor feedback NC',
'抱闸反馈常闭':'Brake feedback NC',
'检修信号常闭':'Inspection signal NC',
'检修/紧急电动上行常闭':'Inspection/EEO up NC',
'检修/紧急电动下行常闭':'Inspection/EEO down NC',
'消防信号常闭':'Fire emergency signal NC',
'上限位常闭':'Up limit signal NC',
'下限位常闭':'Down limit signal NC',
'超载常闭':'Overload NC',
'满载常闭':'Full-load NC',
'消防员运行常闭':'Firefighter operation NC',
'门1光幕常闭':'Door 1 light curtain NC',
'门2光幕常闭':'Door 2 light curtain NC',
'抱闸行程开关1反馈常闭':'Brake travel switch 1 feedback NC',
'停电应急运行常闭':'Emergency evacuation signal NC',
'锁梯常闭':'Elevator lock NC',
'安全回路2反馈常闭':'Safety circuit 2 feedback NC',
'封星反馈常闭':'Shorting motor stator contactor feedback NC',
'门锁回路2反馈常闭':'Door lock circuit 2 feedback NC',
'门1安全触板反馈常开':'Door 1 safety edge feedback NO',
'门2安全触板反馈常开':'Door 2 safety edge feedback NO',
'电机过热常开':'Motor overheat signal NO',
'地震信号常开':'Earthquake signal NO',
'后门禁止常开':'Rear door forbidden signal NO',
'轻载常开':'Light-load NO',
'半载常开':'Half-load NO',
'消防基站切换常开':'Fire emergency floor switchover signal NO',
'假楼层输入常开':'Dummy floor input NC',
'门1开门输入常开':'Door 1 open signal NO',
'门2开门输入常开':'Door 2 open signal NO',
'报闸行程开关2反馈常开':'Brake travel switch 2 feedback NO',
'外部故障输入常开':'External fault input NO ',
'端站校验信号常开':'Terminal floor verification signal NO',
'门锁1短接常开':'Door lock 1 shorting signal NO',
'门锁2短接常开':'Door lock 2 shorting signal NO',
'紧急电动常开':'EEO signal NO',
'电机过热常闭':'Motor overheat signal NC',
'地震信号常闭':'Earthquake signal NC',
'后门禁止常闭':'Rear door forbidden signal NC',
'轻载常闭':'Light-load NC',
'半载常闭':'Half-load NC',
'消防基站切换常闭':'Fire emergency floor switchover signal NC',
'假楼层输入常闭':'Dummy floor input NC',
'门1开门输入常闭':'Door 1 open signal NC',
'门2开门输入常闭':'Door 2 open signal NC',
'报闸行程开关2反馈常闭':'Brake travel switch 2 feedback NC',
'外部故障输入常闭':'External fault input NC',
'端站校验信号常闭':'Terminal floor verification signal NC',
'门锁1短接常闭':'Door lock 1 shorting signal NC',
'门锁2短接常闭':'Door lock 2 shorting signal NC',
'抱闸电机脉冲输入常开':'Motor with brake pulse input NO',
'抱闸微动开关1常开':'Brake micro switch 1 NO',
'抱闸微动开关2常开':'Brake micro switch 2 NO',
'轿顶撑杆开关常开':'Car top balustrade switch NO',
'浸水信号常开':'Pit flooding signal NO',
'抱闸电机脉冲输入常闭':'Motor with brake pulse input NC',
'抱闸微动开关1常闭':'Brake micro switch 1 NC',
'抱闸微动开关2常闭':'Brake micro switch 2 NC',
'轿顶撑杆开关常闭':'Car top balustrade switch NC',
'浸水信号常闭':'Pit flooding signal NC',
'抱闸电机正向输出':'Motor with brake forward running',
'抱闸电机反向输出':'Motor with brake reverse running',
'外召有效':'Hall call allowed',
'禁止外召':'Hall call forbidden',
'允许开门':'Door open allowed',
'禁止开门':'Door open forbidden',
'禁止超载运行':'Overload forbidden',
'允许超载运行':'Overload allowed',
'限位开关有效':'Limit switch enabled',
'限位开关无效':'Limit switch disabled',
'电机无运行':'Motor not running',
'UPS供电运行':'UPS-powered operation',
'48V蓄电池供电运行':'48 V battery power supply',
'外招地址校验':'HCB address check',
'锁梯信号':'Elevator lock signal',
'轻载常开输入#':'Light-load input NO#',
'半载常开输入#':'Half-load input NO#',
'消防基站切换常开输入':'Fire emergency floor switchover input NO',
'假楼层常开输入':'Dummy floor input NO',
'门1开门常开输入':'Door 1 open input NO',
'门2开门常开输入':'Door 2 open input NO',
'轻载常闭输入#':'Light-load input NC#',
'半载常闭输入#':'Half-load input NC#',
'消防基站切换常闭输入':'Fire emergency floor switchover input NC',
'假楼层常闭输入':'Dummy floor input NC',
'门1开门常闭输入':'Door 1 open input NC',
'门2开门常闭输入':'Door 2 open input NC',
'门机 1 开门':'Door open by door operator 1',
'门机 1 关门':'Door close by door operator 1',
'门机 2 开门':'Door open by door operator 2',
'门机 2 关门':'Door close by door operator 2',
'抱闸、运行接触器正常（当出现E37、E36故障时表明抱闸、运行接触器异常）':'Brake and RUN contactors healthy (no faults E37 and E36)',
'故障状态；（3、4、5级故障时输出）':'Fault state (output in level 3/4/5 faults)',
'运行监控；（NICE3000处于运行状态）':'Running monitoring (NICE3000new in running state)',
'抱闸强激输出（每次打开抱闸持续输出4秒）':'High-voltage startup of brake (continuous 4s)',
'电梯上行信号':'UP running signal',
'照明风扇输出':'Lighting/Fan output',
'医用消毒输出#':'Medical sterilization output#',
'非门区停车#':'Non-door zone stop#',
'电锁输出#':'Electromagnetic lock output#',
'救援完成输出':'Emergency evacuation completed',
'消防输出（消防返回和消防员运行时输出）':'Fire emergency output during firefighter operation and when returning to fire emergency floor',
'停电应急状态输出':'Emergency output at power failure',
'下集选':'Down collective selective',
'停止下行':'Stop in down running',
'运行下行':'Down running',
'运行上行':'Up running',
'停止上行':'Stop in up running',
'上下平层':'Up/Down leveling',
'非平层':'Non-leveling ',
'无':'N/A',
'井道自学习':'Shaft auto-tuning',
'微动平层':'Micro-leveling',
'消防返基站':"Firefighter's Return to Designated Floor",
'司机':'Attendant Service',
'自动':'Automatic running',
'空闲泊梯':'Idle elevator parking',
'低速返平层':'Low-speed re-leveling',
'救援运行':'Emergency Rescue Status',
'电机调谐':'Motor auto-tuning',
'键盘控制':'Keypad control',
'基站校验':'Main floor verification',
'VIP状态':'VIP state',
'开启平层调整':'Leveling adjustment enabled',
'说明':'Descriptions',
//cibes控制器名称,
// '标准3000+cibes':'NICE3000new_CIBES',
// '标准3000+系统_435/WLE':'NICE3000new-System_435/WLE',
'层':'floor',
'加速过电流故障':'Overcurrent during acceleration',
'减速过电流故障':'Overcurrent during deceleration',
'恒速过电流故障':'Overcurrent at constant speed',
'加速母线过电压故障':'Acceleration bus overvoltage',
'减速母线过电压故障':'Deceleration bus overvoltage',
'恒速母线过电压故障':'Constant speed bus overvoltage',
'母线欠电压故障':'Bus undervoltage',
'驱动器过载故障':'AC drive overload',
'输入侧缺相故障':'Power supply phase loss',
'输出侧缺相故障':'Output phase loss',
'模块过热故障':'Heatsink overheat',
'制动电阻短路故障':'Braking resistor short circuit',
'电流控制故障':'Current control fault',
'硬件信号检测故障':'Hardware signal detection fault',
'电机调谐故障':'Motor auto-tuning fault',
'参数设置错误':'Parameter setting error',
'平层信号异常':'The leveling signal abnormal',
'对地短路故障':'Short circuit to ground',
'时钟异常':'Clock abnormal',
'存储异常':'Abnormal data access',
'地震信号':'Earthquake signal',
'运行中门锁断开或非本层门锁断开':'During elevator operation, the door lock is disconnected due to malfunction or at a non-current floor',
'折叠门关门受阻超设定次数':'More times of the folding door close that gets hindered than the set limit',
'光电通道脉冲反馈异常和编码器故障':'Photoelectric channel pulse feedback abnormal and encoder fault',
'抱闸输出和PE短路':'Brake output and PE short circuit',
'折叠门开关门受阻故障':'Folding door open/close hindered',
'超速故障触发':'Overspeed fault',
'电梯速度异常':'Elevator speed abnormal',
'逻辑故障':'Logic fault',
'井道自学习数据异常':'Shaft auto-tuning data abnormal',
'运行接触器反馈异常':'RUN contactor feedback abnormal',
'电机过热故障':'Motor overtemperature',
'安全回路断开':'Safety circuit disconnected',
'运行中门锁断开':'Door lock disconnected during running',
'上限位异常':'Up limit signal abnormal',
'下限位异常':'Down limit signal abnormal',
'平层信号丢失':'Loss of leveling signals',
'CAN通讯故障':'CAN communication fault',
'检修启动过电流':'Overcurrent at inspection startup',
'SPI通信故障':'SPI communication fault',
'静态电流故障':'Quiescent current fault',
'外部故障':'External fault',
'通信ARD故障':'Communication fault of ARD',
'物联网故障':'IoT failure',
'最高或最低楼厅门板故障':'HCB fault of top or bottom floor',
'中间楼层厅门板通讯丢失':'Communication loss of HCB on middle floors',
'抱闸电机故障':'Motor with brake fault',
'电锁提锁触点异常':'Abnormal elevator lock contacts',
'电锁过载':'Electromagnetic lock overload',
'浸水信号动作':'Pit flooding signal action',
'维保故障':'Maintenance fault',
'刹车打滑':'Brake slip',
'光电通道脉冲反馈异常':'Photoelectric channel pulse feedback abnormal',
'系统发生错层':'Wrong floor display',
'紧急电动和平台安装模式同时有效':'EEO switch and platform installation mode are active at the same time',
'自动开门器故障':'Automatic door opener fault',
'急停按钮按下或安全边断开':'Emergency stop button pressed or the safety edge disconnected',
'底坑模式触发':'Pit mode triggered',
'ARD故障':'ARD failure',
'安全回路和PE短路':'The safety circuit and PE short circuit',
'消防返基站过程中急停有效或安全边断开':'Emergency stop is effective or safety edge is disconnected in the process of returning to fire emergency floor',
'加速过电流':'Overcurrent during acceleration',
'减速过电流':'Overcurrent during deceleration',
'恒速过电流':'Overcurrent at a constant speed',
'加速过电压':'Overvoltage during acceleration',
'减速过电压':'Overvoltage during deceleration',
'恒速过电压':'Overvoltage at a constant speed',
'上电缓冲继电器不吸合':'Pre-charge relay not closed at power on',
'欠电压故障':'Undervoltage',
'控制器过载':'Controller overload',
'电机过载':'Motor overload',
'输入侧缺相':'Input phase loss',
'输出侧缺相':'Output phase loss',
'模块过热':'Module overtemperature',
'输出侧异常':'Output abnormal',
'电流控制故障':'Current control fault',
'编码器基准信号异常':'Encoder reference signal abnormal',
'电流检测故障':'Current detection fault',
'电机调谐故障':'Motor auto-tuning fault',
'速度反馈错误故障':'Speed feedback incorrect',
'参数设置错误':'Parameter setting error',
'平层信号异常':'The leveling signal abnormal',
'短路故障':'Short circuit',
'RTC 时钟故障':'RTC clock fault',
'存储数据异常':'Storage data abnormal',
'地震信号':'Earthquake signal',
'封星接触器反馈异常':'Shorting motor stator contactor feedback abnormal',
'电梯位置异常':'Elevator position abnormal',
'电梯速度异常':'Elevator speed abnormal',
'逻辑故障':'Logic fault',
'井道自学习数据异常':'Shaft auto-tuning data abnormal',
'运行接触器反馈异常':'RUN contactor feedback abnormal',
'抱闸接触器反馈异常':'Brake contactor feedback abnormal',
'旋转编码器信号异常':'Rotary encoder signal abnormal',
'电机过热故障':'Motor overtemperature',
'电梯运行超时':'Elevator running timeout',
'安全回路断开':'Safety circuit disconnected',
'运行中门锁断开':'Door lock disconnected during running',
'上限位信号异常':'Up limit signal abnormal',
'下限位信号异常':'Down limit signal abnormal',
'强迫减速开关异常':'Slow-down switch abnormal',
'再平层异常':'Re-leveling abnormal',
'封门接触器异常':'Shorting door lock circuit relay abnormal',
'开门故障':'Door open fault',
'关门故障':'Door close fault',
'平层信号连续丢失':'Consecutive loss of leveling signal',
'CAN 通讯故障':'CAN communication fault',
'外召通讯故障':'HCB communication abnormal',
'门锁故障':'Door lock fault',
'检修启动过电流':'Overcurrent at inspection startup',
'换层停靠故障':'Stop at another landing floor',
'开关门信号故障':'Door open/close signal fault',
'SPI 通讯故障':'SPI communication fault',
'位置保护开关异常':'Shaft position switches abnormal',
'模拟量断线':'Analog disconnection',
'外部故障':'External fault',
'UCMP检测异常':'UCMP test abnormal',
'抱闸制动力检测异常':'Braking force test fault',
'STO故障':'STO fault',
'F0基本参数':'Basic parameters of F0',
'F1电机参数':'Parameters of F1 motor',
'F2矢量控制参数':'F2 vector control parameters',
'F3运行控制参数':'F3 operation control parameters',
'F4楼层参数':'Floor parameters of F4',
'F5端子功能参数':'Functional parameters of terminal F5',
'F6电梯逻辑参数':'F6 elevator logical parameters',
'F7测试功能参数':'F7 test function parameters',
'F8增强功能参数':'F8 enhanced function parameters',
'F9时间保护参数':'F9 time protection parameter',
'FA键盘设定':'FA keyboard Settings',
'FB门功能参数':'Function parameters of the FB door',
'FC保护功能参数':'FC protection function parameters',
'FD通讯参数':'FD communication parameters',
'FE显示设置':'FE display Settings',
'FR平层调整':'FR leveling adjustment',
'FP用户参数':'FP user parameters',
'E0第1次故障':'The first failure of E0',
'E1第2次故障':'The second fault of E1',
'E2第3次故障':'The third failure of E2',
'E3第4次故障':'The fourth failure of E3',
'E4第5次故障':'The fifth failure of E4',
'E5第6次故障':'The 6th failure of E5',
'E6第7次故障':'The 7th failure of E6',
'E7第8次故障':'The 8th failure of E7',
'E8第9次故障':'The 9th failure of E8',
'E9第10次故障':'The 10th E9 failure',
'同步机电流滤波系数':'Synchronous motor current filtering coefficient',
'编码器校验选择':'Encoder calibration selection',
'带载、空载调谐、井道自学习':'Load, no-load tuning, and wellbore self-learning',
'打滑实验':"Slip test",
'司机自动转换时间':'The driver automatically switches the time',
'群控数量':'Group control quantity',
'平层感应器延时':'Flat layer sensor delay',
'保安层':'Security layer',
'下集选1开始时间':'Select the start time for episode 1 in the next episode',
'下集选1结束时间':'Choose the end time for episode 1 in the next episode',
'下集选2开始时间':'For the next episode, choose the start time of Episode 2',
'下集选2结束时间':'Choose the end time of Episode 2 in the next episode',
'分时服务1开始':'Time-sharing service 1 begins',
'分时服务1结束':'Time-sharing service 1 has ended',
'分时服务1服务层1':'Time-sharing Service 1 Service Layer 1',
'分时服务1服务层2':'Time-sharing Service 1 Service Layer 2',
'分时服务2开始':'Time-sharing service 2 begins',
'分时服务2结束':'Time-sharing service 2 has ended',
'分时服务2服务层1':'Time-sharing Service 2 Service Layer 1',
'分时服务2服务层2':'Time-sharing Service 2 Service Layer 2',
'并联/群控高峰1开始':'Parallel/Group control peak 1 begins',
'并联/群控高峰1结束':'Parallel/group control peak 1 has ended',
'并联/群控高峰2开始':'Parallel/Group control peak 2 begins',
'并联/群控高峰2结束':'Parallel/group control peak 2 has ended',
'高峰2楼层':'Peak 2nd Floor',
'服务层3':'Service Layer 3',
'分时服务1服务层3':'Time-sharing Service 1 Service Layer 3',
'分时服务2服务层3':'Time-sharing Service 2 Service Layer 3',
'称重学习设定':'Weighing learning Settings',
'预转矩选择':'Pre-torque selection',
'预转矩偏移':'Pre-torque offset',
'驱动侧增益':'Drive side gain',
'制动侧增益':'Braking side gain',
'轿内当前载荷':'The current load inside the car',
'称重空载设置':'No-load weighing setting',
'称重满载设置':'Full load weighing setting',
'外招通讯设置':'External recruitment communication Settings',
'外招辅指令开始地址':'The starting address for external recruitment auxiliary instructions',
'空闲返基站时间':'Idle return time to the base station',
'轿顶节能时间':'The energy-saving time of the car roof',
'运行时间保护':'Running time protection',
'小键盘显示选择':'The numeric keypad displays the selection',
'运行显示':'Running display',
'停机显示':'Shutdown display',
'码盘当前角度':'The current Angle of the code disk',
'开门延时时间':'Door opening delay time',
'外招通讯状态1':'External recruitment communication status 1',
'外招通讯状态2':'External recruitment communication status 2',
'外招通讯状态3':'External recruitment communication status 3',
'特殊开门保持':'Special door opening hold',
'手动保持时间':'Manual hold time',
'强迫关门时间':'Forced closing time',
'门机1服务层3':'Door machine 1 Service Level 3',
'本机地址':'Local address',
'应答延时':'Response delay',
'通讯超时时间':'Communication timeout time',
'返平层停车延时':'Parking delay on the return level',
'门机2服务层3':'Door machine 2 Service Level 3',
'集选方式':'Centralized selection method',
'楼层1显示':'Floor 1 display',
'楼层2显示':'Floor 2 display',
'楼层3显示':'Floor 3 display',
'楼层4显示':'Floor 4 display',
'楼层5显示':'Floor 5 display',
'楼层6显示':'Floor 6 display',
'楼层7显示':'Floor 7 display',
'楼层8显示':'Floor 8 display',
'楼层9显示':'Floor 9 display',
'楼层10显示':'Floor 10 display',
'楼层11显示':'Floor 11 display',
'楼层12显示':'Floor 12 display',
'楼层13显示':'Floor 13 display',
'楼层14显示':'Floor 14 display',
'楼层15显示':'Floor 15 display',
'楼层16显示':'Floor 16 display',
'楼层17显示':'Floor 17 display',
'楼层18显示':'Floor 18 display',
'楼层19显示':'Floor 19 display',
'楼层20显示':'Floor 20 display',
'楼层21显示':'Floor 21 display',
'楼层22显示':'Floor 22 display',
'楼层23显示':'Floor 23 display',
'楼层24显示':'Floor 24 display',
'楼层25显示':'Floor 25 display',
'楼层26显示':'Floor 26 display',
'楼层27显示':'Floor 27 display',
'楼层28显示':'Floor 28 display',
'楼层29显示':'Floor 29 display',
'楼层30显示':'Floor 30 display',
'楼层31显示':'Floor 31 display',
'楼层32显示':'Floor 32 display',
'楼层33显示':'Floor 33 display',
'楼层34显示':'Floor 34 display',
'楼层35显示':'Floor 35 display',
'楼层36显示':'Floor 36 display',
'楼层37显示':'Floor 37 display',
'楼层38显示':'Floor 38 display',
'楼层39显示':'Floor 39 display',
'楼层40显示':'Floor 40 display',
'最高位显示设置1':'The highest bit display setting is 1',
'最高位显示设置2':'The highest bit display setting is 2',
'最高位显示设置3':'The highest bit display setting is 3',
'最高位显示设置4':'The highest bit display setting is 4',
'最高位显示设置5':'The highest bit display setting is 5',
'输入端子状态':'Input terminal status',
'输出端子状态':'Output terminal status',
'高压端子输入状态': 'Input status of high-voltage terminals'


}
/* eslint-disable no-new */